<template>
  <div style="padding: 0px 20px">
    <h1 style="
        margin-top: 0px;
        width: 100%;
        font-size: 32px;
        text-align: center;
        color: #dc6731;
      ">
      企业环境信用填报系统
    </h1>
    <div class="hover-score">
      <div style="width: 100%; text-align: center">
        <span style="color: black">当前得分</span>
      </div>
      <div style="width: 100%; text-align: center">
        <span style="color: red; font-weight: bold; font-size: 24px">{{
          currentScore
        }}</span>
      </div>
    </div>
    <el-collapse v-model="activeNames" v-loading="reviewLoading" element-loading-text="加载中，请耐心等待" @change="handleChange"
      style="padding: 12px; background: white">
      <el-collapse-item name="0">
        <template #title>
          <div style="
              display: flex;
              justify-content: center;
              align-items: center;
              width: 100%;
            ">
            <span style="color: #dc6731; font-weight: bold">平台简介</span>
          </div>
        </template>
        <p>
          1、本系统是依据《中华人民共和国环境保护法》、《企业事业单位环境信息公开办法》、《贵州省企业环境信用评价指标体系及评价方法》、《企业环保信用评价结果等级描述》、《贵州省企业环境信用评价工作指南》、《贵州省生态环境保护失信黑名单管理办》、《贵州省环境保护条例》等法律法规的相关规定和要求，落实企业环境主体责任，为企业环境信用评价工作服务。
          <br />
          2、企业环境信用评价结果等级标识：分为环保诚信、环保良好、环保警示、环保不良4个等级，分别以绿色、蓝色、黄色、红色表示。环保诚信、环保良好、环保警示每一个等级细分为
          三个档次，环保诚信包括：90-95.5分为A、96-99.5分为A+、100分为A++，环保良好包括：75-79.5分为B、80-85.5分为B+、86-89.5分为B++,环保警示包括：60-65.5分为C、66-70.5分为C+、
          71-74.5分为C++，环保不良包括一级一档，59.5分及以下为D。
          <br />
        </p>
      </el-collapse-item>
      <el-collapse-item name="promiseLetter">
        <template #title>
          <span style="color: #dc6731; font-weight: bold">环境信用评价承诺书【必填】</span>
        </template>
        <p>请下载模板填写后上传承诺书</p>
        <a href="http://221.10.90.140:8085/%E8%B4%B5%E5%B7%9E%E7%9C%81%E9%87%8D%E7%82%B9%E6%8E%92%E6%B1%A1%E5%8D%95%E4%BD%8D%E5%8F%82%E5%8A%A0%E7%8E%AF%E5%A2%83%E4%BF%A1%E7%94%A8%E8%AF%84%E4%BB%B7%E5%B7%A5%E4%BD%9C%E6%89%BF%E8%AF%BA%E4%B9%A6.pdf"
          download="环境信用评价承诺书（模板）" target="blank">
          模板下载（右键另存为）
        </a>
        <!-- <el-button @click="downloadPromiseLetter">downloadPromiseLetter</el-button> -->
        <p class="fileText"></p>
        <label>附件: </label>
        <span style="color: blue; cursor: pointer" @click="checkFile(reviewSubmitDatas.promiseLetter)"
          v-if="reviewSubmitDatas.promiseLetter">{{ getFileName(reviewSubmitDatas.promiseLetter) }}</span>
        <input v-else type="file" objName="promiseLetter" filePathKey="fileObj" senum="pm" value=""
          @change="handleUpload" />
        <button v-if="reviewSubmitDatas.promiseLetter" @click="reviewSubmitDatas.promiseLetter = ''">
          重新上传
        </button>
        <p></p>
        <div class="button-container">
          <el-button type='primary' :disabled="!editable"
            @click="saveData({ path: 'Divv4Save', itemPath: 'promiseLetter' })">保存</el-button>
        </div>
      </el-collapse-item>
      <!-- <el-collapse-item name="basicinfo">
              <template #title>
     <span style="color:#dc6731;font-weight:bold">基础资料上传【必填】</span>
    </template>
        		<span style="padding-right:6px">企业说明</span>
        <el-input
       style="width:800px"
          type="textarea"
          autosize
          placeholder="请输入内容"
          v-model="reviewSubmitDatas.basicInfo.remark"
        ></el-input>
        <p></p>
        <template v-for="(item,index) in reviewSubmitDatas.basicInfo.huanPingWenJianList">
          <p></p>
        <label>环评文件: </label>
         <span
          style="color: blue; cursor: pointer"
          @click="
            checkFile(item.filePath)
          "
          v-if="item.filePath"
          >{{getFileName(item.filePath) }}</span
        >
        <input
      
          v-else
           type="file"
                accept=".pdf,image/*"
          objName="basicInfo"
          filePathKey="huanPingWenJianList"
          :filePathKey2="index"
          senum="2"
          value=""
          @change="handleUpload"
        />
        <button fileLabel="huanPingWenJianList" @click='addFileList'>新增</button>
       <button fileLabel="huanPingWenJianList" v-if="reviewSubmitDatas.basicInfo.huanPingWenJianList.length>1" :idx="index" @click='delFileList'>删除</button>
        <p></p>
        </template>
         <p></p>
        <template v-for="(item,index) in reviewSubmitDatas.basicInfo.piFuWenJianList">
          <p></p>
        <label>批复文件: </label>
         <span
          style="color: blue; cursor: pointer"
          @click="
            checkFile(item.filePath)
          "
          v-if="item.filePath"
          >{{getFileName(item.filePath) }}</span
        >
        <input
      
          v-else
           type="file"
                accept=".pdf,image/*"
          objName="basicInfo"
          filePathKey="piFuWenJianList"
          :filePathKey2="index"
          senum="2"
          value=""
          @change="handleUpload"
        />
        <button fileLabel="piFuWenJianList" @click='addFileList'>新增</button>
      <button fileLabel="piFuWenJianList" v-if="reviewSubmitDatas.basicInfo.piFuWenJianList.length>1" :idx="index" @click='delFileList'>删除</button>
   
        <p></p>
        </template>
         <p></p>
        <template v-for="(item,index) in reviewSubmitDatas.basicInfo.yanShouWenJianList">
          <p></p>
        <label>验收文件: </label>
         <span
          style="color: blue; cursor: pointer"
          @click="
            checkFile(item.filePath)
          "
          v-if="item.filePath"
          >{{getFileName(item.filePath) }}</span
        >
        <input
      
          v-else
           type="file"
                accept=".pdf,image/*"
          objName="basicInfo"
          filePathKey="yanShouWenJianList"
          :filePathKey2="index"
          senum="2"
          value=""
          @change="handleUpload"
        />
        <button fileLabel="yanShouWenJianList" @click='addFileList'>新增</button>
      <button fileLabel="yanShouWenJianList" v-if="reviewSubmitDatas.basicInfo.yanShouWenJianList.length>1" :idx="index" @click='delFileList'>删除</button>
   
        <p></p>
        </template>
      <label>三同时验收材料: </label>
        <span
          style="color: blue; cursor: pointer"
          @click="
            checkFile(reviewSubmitDatas.basicInfo.tongShiYanShou.filePath)
          "
          v-if="reviewSubmitDatas.basicInfo.tongShiYanShou.fileName"
          >{{ reviewSubmitDatas.basicInfo.tongShiYanShou.fileName }}</span
        >
        <input
          v-else
           type="file"
                accept=".pdf,image/*"
          objName="basicInfo"
          filePathKey="tongShiYanShou"
          senum="2"
          value=""
          @change="handleUpload"
        /> 
        </p> 
         <label>排污许可证: </label>
       <span
          style="color: blue; cursor: pointer"
          @click="checkFile(reviewSubmitDatas.reviewItem7.fileObj.filePath)"
          v-if="reviewSubmitDatas.reviewItem7.fileObj.filePath"
          >{{ getFileName(reviewSubmitDatas.reviewItem7.fileObj.filePath) }}</span
        >   <span v-else>无</span>
          <p></p>
        <label>突发环境事件风险评估报告: </label>
              <span
          style="color: blue; cursor: pointer"
          @click="checkFile(reviewSubmitDatas.reviewItem11.fileObj1.filePath)"
          v-if="reviewSubmitDatas.reviewItem11.fileObj1.filePath"
          >{{ getFileName(reviewSubmitDatas.reviewItem11.fileObj1.filePath) }}</span
        >
        <span v-else>无</span>
           <p></p>
        <label>突发环境事件应急预案: </label>
         <span
          style="color: blue; cursor: pointer"
          @click="checkFile(reviewSubmitDatas.reviewItem11.fileObj2.filePath)"
          v-if="reviewSubmitDatas.reviewItem11.fileObj2.filePath"
          >{{ getFileName(reviewSubmitDatas.reviewItem11.fileObj2.filePath) }}</span
        >   <span v-else>无</span> <p></p>
        <label>排污许可证（全本）: </label>
        <span
          style="color: blue; cursor: pointer"
          @click="checkFile(reviewSubmitDatas.basicInfo.paiWuXuKe.filePath)"
          v-if="reviewSubmitDatas.basicInfo.paiWuXuKe.fileName"
          >{{ reviewSubmitDatas.basicInfo.paiWuXuKe.fileName }}</span
        >
        <input
          v-else
           type="file"
                accept=".pdf,image/*"
          objName="basicInfo"
          filePathKey="paiWuXuKe"
          senum="2"
          value=""
          @change="handleUpload"
        />
        <p></p>
        <label>突发环境事件风险评估报告（全本）: </label>
        <span
          style="color: blue; cursor: pointer"
          @click="
            checkFile(reviewSubmitDatas.basicInfo.fengXianPingGu.filePath)
          "
          v-if="reviewSubmitDatas.basicInfo.fengXianPingGu.fileName"
          >{{ reviewSubmitDatas.basicInfo.fengXianPingGu.fileName }}</span
        >
        <input
          v-else
           type="file"
                accept=".pdf,image/*"
          objName="basicInfo"
          filePathKey="fengXianPingGu"
          senum="2"
          value=""
          @change="handleUpload"
        />
        <p></p>
        <label>突发环境事件应急预案（全本）: </label>
        <span
          style="color: blue; cursor: pointer"
          @click="checkFile(reviewSubmitDatas.basicInfo.yingJiYuAn.filePath)"
          v-if="reviewSubmitDatas.basicInfo.yingJiYuAn.fileName"
          >{{ reviewSubmitDatas.basicInfo.yingJiYuAn.fileName }}</span
        >
        <input
          v-else
           type="file"
                accept=".pdf,image/*"
          objName="basicInfo"
          filePathKey="yingJiYuAn"
          senum="2"
          value=""
          @change="handleUpload"
        /> 
        <p><b>备注：</b></p>
        <p><b>1.环评需提供企业所有的环评文本、批复、验收材料</b></p>
        <p><b>2.企业需提供有效覆盖当前评价年度的材料</b></p>
        <p><b>3.附件材料请提供PDF、JPG或PNG格式</b></p>
        <div class="button-container">
  <el-button
       type='primary'
          @click="saveData({ path: 'Div30Save', itemPath: 'basicInfo' })"
          >保存</el-button
        >
        </div>
      
      </el-collapse-item>  -->
      <el-collapse-item name="1">
        <template #title>
          <span style="color: #dc6731; font-weight: bold">单位证明【企业自评与填报】</span>
        </template>
        <p>企业名称与营业执照不符情况说明</p>
        <el-input style="width: 800px" type="textarea" autosize placeholder="请输入内容"
          v-model="reviewSubmitDatas.danWeiZhengMing.remark"></el-input>
        <p></p>
        <el-input style="width: 70vh" type="text" maxlength="18" show-word-limit
          v-model="reviewSubmitDatas.danWeiZhengMing.xinYongDaiMa" placeholder="单位统一社会信用代码">
          <template #preped><span style="color: red">*</span>单位统一社会信用代码</template>
          <el-button #appen @click="checkOrgCode">审核查看</el-button>
        </el-input>
        <p></p>
        <el-select v-model="reviewSubmitDatas.danWeiZhengMing.companyStatus" class="m-2" placeholder="选择单位状态"
          size="large">
          <el-option v-for="item in optionsDatas.companyStatusOptions" :key="item.value" :label="item.label"
            :value="item.value" />
        </el-select>
        <p></p>
        <label><span style="color: red">*</span>企业营业执照: </label>

        <span style="color: blue; cursor: pointer" @click="
          checkFile(reviewSubmitDatas.danWeiZhengMing.yinYeZhiZhao.filePath)
          " v-if="reviewSubmitDatas.danWeiZhengMing.yinYeZhiZhao.filePath">{{
    getFileName(reviewSubmitDatas.danWeiZhengMing.yinYeZhiZhao.filePath)
  }}</span>
        <input v-else type="file" accept=".pdf,image/*" objName="danWeiZhengMing" filePathKey="yinYeZhiZhao" senum="yyzz"
          value="" @change="handleUpload" />
        <button v-if="reviewSubmitDatas.danWeiZhengMing.yinYeZhiZhao.filePath"
          @click="reviewSubmitDatas.danWeiZhengMing.yinYeZhiZhao.filePath = ''">
          重新上传
        </button>

        <br />

        <p style="color: red">
          *评价年度超过半年以上停产企业、超过半年以上未投产企业，佐证材料（加盖主管部门公章）和营业执照一起合并上传。
        </p>
        <div class="button-container">
          <el-button type='primary' :disabled="!editable" @click="
            saveData({ path: 'Divv1Save', itemPath: 'danWeiZhengMing' })
            ">保存</el-button>
        </div>
      </el-collapse-item>
      <!-- <el-collapse-item name="2">
				<template #title>
					<span style="color:#dc6731;font-weight:bold">单位状态【企业自评与填报】</span>
				</template>
				<p>
					参评年度: <span>{{ reviewSubmitDatas.danWeiZhuangTai.year }}</span>
				</p>
				<p>单位状态</p>
				<el-select v-model="reviewSubmitDatas.danWeiZhuangTai.companyStatus" placeholder="请选择"
					:disabled="isOrg">
					<el-option v-for="item in optionsDatas.companyStatusOptions" :key="item.value" :label="item.label"
						:value="item.value">
					</el-option>
				</el-select>
			<p class="fileText"></p>
				<label>未参评证明: </label>
				<span style="color: blue; cursor: pointer"
					@click="checkFile(reviewSubmitDatas.danWeiZhuangTai.fileObj.filePath)"
					v-if="reviewSubmitDatas.danWeiZhuangTai.fileObj.filePath">{{ getFileName(reviewSubmitDatas.danWeiZhuangTai.fileObj.filePath) }}</span>
				<input :disabled="isOrg" v-else  type="file"
                accept=".pdf,image/*" objName="danWeiZhuangTai" filePathKey="fileObj" senum="2"
					value="" @change="handleUpload" />
				<button v-if="reviewSubmitDatas.danWeiZhuangTai.fileObj.filePath"
					@click="reviewSubmitDatas.danWeiZhuangTai.fileObj.filePath=''">重新上传</button>

			<p ></p>
				<div class="button-container">
					<el-button disabled type='primary'
						@click="saveData({ path: 'Divv2Save', itemPath: 'danWeiZhuangTai' })">保存</el-button>
				</div>
			</el-collapse-item> -->

      <!-- <el-collapse-item name="3">
				<template #title>
					<span style="font-weight:bold">一票否决【企业自评与填报】</span>
				</template>
				<el-switch v-model="reviewSubmitDatas.yiPiaoFouJue.isNotOnePollOut" active-color="#13ce66"
					inactive-color="#ff4949" active-text="非一票否决" inactive-text="一票否决">
				</el-switch>
			<p class="fileText"></p>
				<el-checkbox-group @change="
            onePollOutPrint(
              reviewSubmitDatas.yiPiaoFouJue.onePollOutList,
              'yiPiaoFouJue'
            )
          "
          v-model="reviewSubmitDatas.yiPiaoFouJue.onePollOutList"
          v-if="!reviewSubmitDatas.yiPiaoFouJue.isNotOnePollOut"
        >
          <template v-for="item in optionsDatas.onePollOutOptions">
            <el-checkbox :value="item.value" :label="item.value">{{item.label}}</el-checkbox>
            <br />
          </template>
        </el-checkbox-group>
        <div   v-if="!reviewSubmitDatas.yiPiaoFouJue.isNotOnePollOut">
  <label>附件: </label>
        <span
          style="color: blue; cursor: pointer"
          @click="checkFile(reviewSubmitDatas.yiPiaoFouJue.fileObj.filePath)"
          v-if="reviewSubmitDatas.yiPiaoFouJue.fileObj.filePath"
          >{{ getFileName(reviewSubmitDatas.yiPiaoFouJue.fileObj.filePath) }}</span
        >
        <input
          v-else
           type="file"
                accept=".pdf,image/*"
          objName="yiPiaoFouJue"
          filePathKey="fileObj"
          senum="2"
          value=""
          @change="handleUpload"
        />
        <button   v-if="reviewSubmitDatas.yiPiaoFouJue.fileObj.filePath" @click="reviewSubmitDatas.yiPiaoFouJue.fileObj.filePath=''">重新上传</button>
        <br />
        </div>
      
        <p>
          得分值：<span>{{ reviewSubmitDatas.yiPiaoFouJue.score }}</span>
        </p>
        <br />
        <div class="button-container">
        <el-button
            type='primary'
          @click="saveData({ path: 'Divv3Save', itemPath: 'yiPiaoFouJue' })"
          >保存</el-button
        >
        </div>
      </el-collapse-item> -->

      <el-collapse-item name="4">
        <template #title>
          <span style="color: #dc6731; font-weight: bold">1、污染源自动在线监控【企业自评与填报】</span>
        </template>
        <span style="padding-right: 8px">企业说明</span>
        <el-input style="width: 800px" type="textarea" autosize placeholder="请输入内容"
          v-model="reviewSubmitDatas.reviewItem1.remark"></el-input>
        <!-- <el-image
          style="
            height: 150px;
            width: 267px;
            float: right;
            margin: 20px 80px 20px 0px;
          "
          :src="'../../assets/images/guizhouReviewHints/guizhouHints_1.jpg'"
          :preview-src-list="[
            require('../../assets/images/guizhouReviewHints/guizhouHints_1.jpg'),
          ]"
        >
        </el-image> -->
        <el-image style="
            height: 150px;
            width: 267px;
            float: right;
            margin: 20px 80px 20px 0px;
          " :src="require('../../assets/images/guizhouReviewHints/guizhouHints_1.jpg')
            " :preview-src-list="[
    require('../../assets/images/guizhouReviewHints/guizhouHints_1.jpg'),
  ]">
        </el-image>
        <div v-if="reviewSubmitDatas.reviewItem1.radioSelect2 != 3">
          <p></p>
          <el-checkbox v-if="!reviewSubmitDatas.reviewItem1.selectedOptions.includes('1')"
            v-model="reviewSubmitDatas.reviewItem1.radioSelect1">按规定无需安装自动监控设备（6.5分）</el-checkbox>
          <p></p>

          <el-checkbox-group v-if="!reviewSubmitDatas.reviewItem1.radioSelect1"
            v-model="reviewSubmitDatas.reviewItem1.selectedOptions">
            <el-checkbox label="1">按规定安装自动监控设备（2分）</el-checkbox>
            <br />
            <el-checkbox label="2">与生态环境部门联网并完成验收（2分）</el-checkbox>
            <br />
            <el-checkbox label="3">按照技术规范开展运行维护管理（1分）</el-checkbox>
          </el-checkbox-group>
        </div>
        <p></p>
        <el-radio-group v-if="!reviewSubmitDatas.reviewItem1.radioSelect1"
          v-model="reviewSubmitDatas.reviewItem1.radioSelect2" class="radioDiv">
          <div>
            <el-radio :label="1">自动监控设备年传输上报率≥90%（1.5分）</el-radio>
          </div>
          <div>
            <el-radio :label="2">80≤自动监控设备年传输上报率＜90%（1分）</el-radio>
          </div>

          <div>
            <el-radio :label="3">按规定应安装而未安装自动监控设备或在
              线监测数据弄虚作假（0分）</el-radio>
          </div>
        </el-radio-group>
        <p class="fileText"></p>
        <div v-if="!reviewSubmitDatas.reviewItem1.selectedOptions.includes('1') &&
          reviewSubmitDatas.reviewItem1.radioSelect1
          ">
          <label>附件1（情况说明）: </label>
          <span style="color: blue; cursor: pointer" @click="checkFile(reviewSubmitDatas.reviewItem1.fileObj1.filePath)"
            v-if="reviewSubmitDatas.reviewItem1.fileObj1.filePath">{{
              getFileName(reviewSubmitDatas.reviewItem1.fileObj1.filePath)
            }}</span>
          <input v-else type="file" accept=".pdf,image/*" objName="reviewItem1" filePathKey="fileObj1" senum="1" value=""
            @change="handleUpload" />
          <button v-if="reviewSubmitDatas.reviewItem1.fileObj1.filePath"
            @click="reviewSubmitDatas.reviewItem1.fileObj1.filePath = ''">
            重新上传
          </button>
          <p></p>
        </div>
        <p class="fileText"></p>
        <div v-if="!reviewSubmitDatas.reviewItem1.radioSelect1">
          <div v-if="reviewSubmitDatas.reviewItem1.selectedOptions.includes('1') &&
            reviewSubmitDatas.reviewItem1.radioSelect2 != 3
            ">
            <label>附件2（设备型号、安装时间等）: </label>
            <span style="color: blue; cursor: pointer" @click="
              checkFile(reviewSubmitDatas.reviewItem1.fileObj2.filePath)
              " v-if="reviewSubmitDatas.reviewItem1.fileObj2.filePath">{{
    getFileName(reviewSubmitDatas.reviewItem1.fileObj2.filePath)
  }}</span>
            <input v-else type="file" accept=".pdf,image/*" objName="reviewItem1" filePathKey="fileObj2" senum="1"
              value="" @change="handleUpload" />
            <button v-if="reviewSubmitDatas.reviewItem1.fileObj2.filePath"
              @click="reviewSubmitDatas.reviewItem1.fileObj2.filePath = ''">
              重新上传
            </button>
            <p class="fileText"></p>
          </div>

          <div v-if="reviewSubmitDatas.reviewItem1.selectedOptions.includes('2') &&
            reviewSubmitDatas.reviewItem1.radioSelect2 != 3
            ">
            <label>附件3（验收和联网）: </label>
            <span style="color: blue; cursor: pointer" @click="
              checkFile(reviewSubmitDatas.reviewItem1.fileObj3.filePath)
              " v-if="reviewSubmitDatas.reviewItem1.fileObj3.filePath">{{
    getFileName(reviewSubmitDatas.reviewItem1.fileObj3.filePath)
  }}</span>
            <input v-else type="file" accept=".pdf,image/*" objName="reviewItem1" filePathKey="fileObj3" senum="1"
              value="" @change="handleUpload" />
            <button v-if="reviewSubmitDatas.reviewItem1.fileObj3.filePath"
              @click="reviewSubmitDatas.reviewItem1.fileObj3.filePath = ''">
              重新上传
            </button>

            <p class="fileText"></p>
          </div>

          <div v-if="reviewSubmitDatas.reviewItem1.selectedOptions.includes('3') &&
            reviewSubmitDatas.reviewItem1.radioSelect2 != 3
            ">
            <label>附件4（运行和维护）: </label>
            <span style="color: blue; cursor: pointer" @click="
              checkFile(reviewSubmitDatas.reviewItem1.fileObj4.filePath)
              " v-if="reviewSubmitDatas.reviewItem1.fileObj4.filePath">{{
    getFileName(reviewSubmitDatas.reviewItem1.fileObj4.filePath)
  }}</span>
            <input v-else type="file" accept=".pdf,image/*" objName="reviewItem1" filePathKey="fileObj4" senum="1"
              value="" @change="handleUpload" />
            <button v-if="reviewSubmitDatas.reviewItem1.fileObj4.filePath"
              @click="reviewSubmitDatas.reviewItem1.fileObj4.filePath = ''">
              重新上传
            </button>

            <p class="fileText"></p>
          </div>
          <div v-if="reviewSubmitDatas.reviewItem1.radioSelect2 != 3">
            <label>附件5（年传输上报率）: </label>
            <span style="color: blue; cursor: pointer" @click="
              checkFile(reviewSubmitDatas.reviewItem1.fileObj5.filePath)
              " v-if="reviewSubmitDatas.reviewItem1.fileObj5.filePath">{{
    getFileName(reviewSubmitDatas.reviewItem1.fileObj5.filePath)
  }}</span>
            <input v-else type="file" accept=".pdf,image/*" objName="reviewItem1" filePathKey="fileObj5" senum="1"
              value="" @change="handleUpload" />
            <button v-if="reviewSubmitDatas.reviewItem1.fileObj5.filePath"
              @click="reviewSubmitDatas.reviewItem1.fileObj5.filePath = ''">
              重新上传
            </button>
          </div>
        </div>

        <br />
        <div class="button-container">
          <p>
            得分值：<span>{{ reviewSubmitDatas.reviewItem1.score }}</span>
          </p>
          <el-button type='primary' :disabled="!editable"
            @click="saveData({ path: 'Div1Save', itemPath: 'reviewItem1' })">
            保存
          </el-button>
        </div>
      </el-collapse-item>
      <el-collapse-item title="2、污染源监督性监测【企业自评与填报】" name="5">
        <template #title>
          <span style="color: #dc6731; font-weight: bold">2、污染源监督性监测【企业自评与填报】</span>
        </template>
        <span style="padding-right: 6px">企业说明</span>
        <el-input style="width: 800px" type="textarea" autosize placeholder="请输入内容"
          v-model="reviewSubmitDatas.reviewItem2.remark"></el-input>
        <el-image style="
            height: 150px;
            width: 267px;
            float: right;
            margin: 20px 80px 20px 0px;
          " :src="require('../../assets/images/guizhouReviewHints/guizhouHints_2.jpg')
            " :preview-src-list="[
    require('../../assets/images/guizhouReviewHints/guizhouHints_2.jpg'),
  ]">
        </el-image>
        <p></p>
        <el-radio-group class="radioDiv" v-model="reviewSubmitDatas.reviewItem2.radioSelect">
          <div>
            <el-radio :label="1">按规定无需开展污染源监督性监测（5分）</el-radio>
          </div>
          <div>
            <el-radio :label="2">全年达标率大于≥90%（5分）</el-radio>
          </div>

          <div><el-radio :label="3">75%≤全年达标率＜90%（3分）</el-radio></div>
          <div><el-radio :label="4">65%≤全年达标率＜75%（2分）</el-radio></div>
          <div><el-radio :label="5">50%≤全年达标率＜65%（1分）</el-radio></div>
          <div><el-radio :label="6">全年达标率＜50%（0分）</el-radio></div>
        </el-radio-group>
        <p class="fileText"></p>
        <label>附件（情况说明、监督性监测报告）: </label>

        <span style="color: blue; cursor: pointer" @click="checkFile(reviewSubmitDatas.reviewItem2.fileObj.filePath)"
          v-if="reviewSubmitDatas.reviewItem2.fileObj.filePath">{{
            getFileName(reviewSubmitDatas.reviewItem2.fileObj.filePath)
          }}</span>

        <input v-else type="file" accept=".pdf,image/*" objName="reviewItem2" filePathKey="fileObj" senum="2" value=""
          @change="handleUpload" />
        <button v-if="reviewSubmitDatas.reviewItem2.fileObj.filePath"
          @click="reviewSubmitDatas.reviewItem2.fileObj.filePath = ''">
          重新上传
        </button>

        <br />
        <p></p>
        <div class="button-container">
          <p>
            得分值：<span>{{ reviewSubmitDatas.reviewItem2.score }}</span>
          </p>
          <el-button type='primary' :disabled="!editable"
            @click="saveData({ path: 'Div2Save', itemPath: 'reviewItem2' })">
            保存</el-button>
        </div>
      </el-collapse-item>
      <el-collapse-item title="3、企业自行监测【企业自评与填报】" name="6">
        <template #title>
          <span style="color: #dc6731; font-weight: bold">3、企业自行监测【企业自评与填报】</span>
        </template>
        <span style="padding-right: 6px">企业说明</span>
        <el-input style="width: 800px" type="textarea" autosize placeholder="请输入内容"
          v-model="reviewSubmitDatas.reviewItem3.remark"></el-input>
        <el-image style="
            height: 150px;
            width: 267px;
            float: right;
            margin: 20px 80px 20px 0px;
          " :src="require('../../assets/images/guizhouReviewHints/guizhouHints_3.jpg')
            " :preview-src-list="[
    require('../../assets/images/guizhouReviewHints/guizhouHints_3.jpg'),
  ]">
        </el-image>
        <p></p>
        <el-checkbox v-model="reviewSubmitDatas.reviewItem3.radioSelect1">按规定无需开展企业自行监测(3分)</el-checkbox>
        <p></p>
        <div v-if="!reviewSubmitDatas.reviewItem3.radioSelect1">
          <p></p>
          <el-checkbox v-model="reviewSubmitDatas.reviewItem3.radioSelect4">自行监测完成率</el-checkbox>
          <p></p>
          <el-radio-group v-model="reviewSubmitDatas.reviewItem3.radioSelect2"
            v-if="reviewSubmitDatas.reviewItem3.radioSelect4" class="radioDiv">
            <div> <el-radio :label="1">全面开展了自行监测，且自行监测完成率≥80%（1.5分）</el-radio></div>

            <div> <el-radio :label="2">70%≤自行监测完成率＜80%（1分）</el-radio></div>
            <div><el-radio :label="3">60%≤自行监测完成率＜70%（0.5分）</el-radio></div>
            <div><el-radio :label="4">未按要求开展自行监测或自行监测完成率＜60%（0分）</el-radio></div>
          </el-radio-group>
          <p></p>
          <el-checkbox v-model="reviewSubmitDatas.reviewItem3.radioSelect5">自行监测公布率</el-checkbox>
          <p></p>
          <el-radio-group v-model="reviewSubmitDatas.reviewItem3.radioSelect3"
            v-if="reviewSubmitDatas.reviewItem3.radioSelect5" class="radioDiv">
            <div> <el-radio :label="1">自行监测公布率≥90%（1.5分）</el-radio></div>
            <div> <el-radio :label="2">80%≤自行监测公布率＜90%（1分）</el-radio></div>
            <div><el-radio :label="3">70%≤自行监测公布率＜80%（0.5分）</el-radio></div>
            <div> <el-radio :label="4">自行监测公布率＜70%（0分）</el-radio></div>
          </el-radio-group>
        </div>
        <div v-if="reviewSubmitDatas.reviewItem3.radioSelect1">
          <p class="fileText"></p>
          <label>附件（无需开展企业自行监测）: </label>
          <span style="color: blue; cursor: pointer" @click="checkFile(reviewSubmitDatas.reviewItem3.fileObj1.filePath)"
            v-if="reviewSubmitDatas.reviewItem3.fileObj1.filePath">{{
              getFileName(reviewSubmitDatas.reviewItem3.fileObj1.filePath)
            }}</span>
          <input v-else type="file" accept=".pdf,image/*" objName="reviewItem3" filePathKey="fileObj1" senum="3" value=""
            @change="handleUpload" />
          <button v-if="reviewSubmitDatas.reviewItem3.fileObj1.filePath"
            @click="reviewSubmitDatas.reviewItem3.fileObj1.filePath = ''">
            重新上传
          </button>
          <!-- <p class="fileText"></p> -->
        </div>

        <div v-if="reviewSubmitDatas.reviewItem3.radioSelect4 &&
          !reviewSubmitDatas.reviewItem3.radioSelect1
          ">
          <label>附件（自行监测完成率）: </label>
          <span style="color: blue; cursor: pointer" @click="checkFile(reviewSubmitDatas.reviewItem3.fileObj2.filePath)"
            v-if="reviewSubmitDatas.reviewItem3.fileObj2.filePath">{{
              getFileName(reviewSubmitDatas.reviewItem3.fileObj2.filePath)
            }}</span>
          <input v-else type="file" accept=".pdf,image/*" objName="reviewItem3" filePathKey="fileObj2" senum="3" value=""
            @change="handleUpload" />
          <button v-if="reviewSubmitDatas.reviewItem3.fileObj2.filePath"
            @click="reviewSubmitDatas.reviewItem3.fileObj2.filePath = ''">
            重新上传
          </button>
        </div>
        <div v-if="reviewSubmitDatas.reviewItem3.radioSelect5 &&
          !reviewSubmitDatas.reviewItem3.radioSelect1
          ">
          <p class="fileText"></p>
          <label>附件（自行监测公布率）: </label>
          <span style="color: blue; cursor: pointer" @click="checkFile(reviewSubmitDatas.reviewItem3.fileObj3.filePath)"
            v-if="reviewSubmitDatas.reviewItem3.fileObj3.filePath">{{
              getFileName(reviewSubmitDatas.reviewItem3.fileObj3.filePath)
            }}</span>
          <input v-else type="file" accept=".pdf,image/*" objName="reviewItem3" filePathKey="fileObj3" senum="3" value=""
            @change="handleUpload" />
          <button v-if="reviewSubmitDatas.reviewItem3.fileObj3.filePath"
            @click="reviewSubmitDatas.reviewItem3.fileObj3.filePath = ''">
            重新上传
          </button>
        </div>
        <p></p>
        <div class="button-container">
          <p>
            得分值：<span>{{ reviewSubmitDatas.reviewItem3.score }}</span>
          </p>
          <el-button type='primary' :disabled="!editable"
            @click="saveData({ path: 'Div3Save', itemPath: 'reviewItem3' })">
            保存</el-button>
        </div>
      </el-collapse-item>

      <el-collapse-item title="4、排污许可和总量控制【企业自评与填报】" name="7">
        <template #title>
          <span style="color: #dc6731; font-weight: bold">4、排污许可和总量控制【企业自评与填报】</span>
        </template>
        <span style="padding-right: 6px">企业说明</span>
        <el-input style="width: 800px" type="textarea" autosize placeholder="请输入内容"
          v-model="reviewSubmitDatas.reviewItem4.remark"></el-input>
        <el-image style="
            height: 150px;
            width: 267px;
            float: right;
            margin: 20px 80px 20px 0px;
          " :src="require('../../assets/images/guizhouReviewHints/guizhouHints_4.jpg')
            " :preview-src-list="[
    require('../../assets/images/guizhouReviewHints/guizhouHints_4.jpg'),
  ]">
        </el-image>
        <p></p>
        <el-checkbox v-model="reviewSubmitDatas.reviewItem4.radioSelect1">按规定无需办理排污许可证(4分)</el-checkbox>
        <p></p>
        <div v-if="!reviewSubmitDatas.reviewItem4.radioSelect1">
          <p></p>
          <el-checkbox v-model="reviewSubmitDatas.reviewItem4.radioSelect4">排污许可证</el-checkbox>
          <p></p>
          <el-radio-group v-model="reviewSubmitDatas.reviewItem4.radioSelect2"
            v-if="reviewSubmitDatas.reviewItem4.radioSelect4" class="radioDiv">
            <div> <el-radio :label="1">依法办理排污许可证（2分）</el-radio></div>
            <div> <el-radio :label="2">未依法办理排污许可证（0分）</el-radio></div>
          </el-radio-group>
          <p></p>
          <el-checkbox v-model="reviewSubmitDatas.reviewItem4.radioSelect5">企业排放总量</el-checkbox>
          <p></p>
          <el-radio-group v-model="reviewSubmitDatas.reviewItem4.radioSelect3"
            v-if="reviewSubmitDatas.reviewItem4.radioSelect5" class="radioDiv">
            <div><el-radio :label="1">企业排放总量全部符合许可量要求（2分）</el-radio></div>
            <div><el-radio :label="2">企业排放总量任意一项不符合许可量要求（0分）</el-radio></div>
          </el-radio-group>
        </div>

        <div v-if="reviewSubmitDatas.reviewItem4.radioSelect1">
          <p class="fileText"></p>
          <label>附件（无需办理排污许可证）: </label>
          <span style="color: blue; cursor: pointer" @click="checkFile(reviewSubmitDatas.reviewItem4.fileObj1.filePath)"
            v-if="reviewSubmitDatas.reviewItem4.fileObj1.filePath">{{
              getFileName(reviewSubmitDatas.reviewItem4.fileObj1.filePath)
            }}</span>
          <input v-else type="file" accept=".pdf,image/*" objName="reviewItem4" filePathKey="fileObj1" senum="4" value=""
            @change="handleUpload" />
          <button v-if="reviewSubmitDatas.reviewItem4.fileObj1.filePath"
            @click="reviewSubmitDatas.reviewItem4.fileObj1.filePath = ''">
            重新上传
          </button>
        </div>
        <div v-if="reviewSubmitDatas.reviewItem4.radioSelect4 &&
          !reviewSubmitDatas.reviewItem4.radioSelect1
          ">
          <p class="fileText"></p>
          <label>附件（排污许可证）: </label>
          <span style="color: blue; cursor: pointer" @click="checkFile(reviewSubmitDatas.reviewItem4.fileObj1.filePath)"
            v-if="reviewSubmitDatas.reviewItem4.fileObj1.filePath">{{
              getFileName(reviewSubmitDatas.reviewItem4.fileObj1.filePath)
            }}</span>
          <input v-else type="file" accept=".pdf,image/*" objName="reviewItem4" filePathKey="fileObj1" senum="4" value=""
            @change="handleUpload" />
          <button v-if="reviewSubmitDatas.reviewItem4.fileObj1.filePath"
            @click="reviewSubmitDatas.reviewItem4.fileObj1.filePath = ''">
            重新上传
          </button>
        </div>
        <div v-if="reviewSubmitDatas.reviewItem4.radioSelect5 &&
          !reviewSubmitDatas.reviewItem4.radioSelect1
          ">
          <p class="fileText"></p>
          <label>附件（企业排放总量）: </label>
          <span style="color: blue; cursor: pointer" @click="checkFile(reviewSubmitDatas.reviewItem4.fileObj2.filePath)"
            v-if="reviewSubmitDatas.reviewItem4.fileObj2.filePath">{{
              getFileName(reviewSubmitDatas.reviewItem4.fileObj2.filePath)
            }}</span>
          <input v-else type="file" accept=".pdf,image/*" objName="reviewItem4" filePathKey="fileObj2" senum="4" value=""
            @change="handleUpload" />
          <button v-if="reviewSubmitDatas.reviewItem4.fileObj2.filePath"
            @click="reviewSubmitDatas.reviewItem4.fileObj2.filePath = ''">
            重新上传
          </button>
        </div>

        <p></p>
        <div class="button-container">
          <p>
            得分值：<span>{{ reviewSubmitDatas.reviewItem4.score }}</span>
          </p>
          <el-button type='primary' :disabled="!editable"
            @click="saveData({ path: 'Div4Save', itemPath: 'reviewItem4' })">
            保存</el-button>
        </div>
      </el-collapse-item>
      <el-collapse-item title="5、危险废物管理与处置【企业自评与填报】" name="8">
        <template #title>
          <span style="color: #dc6731; font-weight: bold">5、危险废物管理与处置【企业自评与填报】</span>
        </template>
        <span style="padding-right: 6px">企业说明</span>
        <el-input style="width: 800px" type="textarea" autosize placeholder="请输入内容"
          v-model="reviewSubmitDatas.reviewItem5.remark"></el-input>
        <el-image style="
            height: 150px;
            width: 267px;
            float: right;
            margin: 20px 80px 20px 0px;
          " :src="require('../../assets/images/guizhouReviewHints/guizhouHints_5.jpg')
            " :preview-src-list="[
    require('../../assets/images/guizhouReviewHints/guizhouHints_5.jpg'),
  ]">
        </el-image>
        <p></p>
        <el-checkbox v-if="!reviewSubmitDatas.reviewItem5.radioSelect3"
          v-model="reviewSubmitDatas.reviewItem5.radioSelect1">无危险废物处置要求的(5.5分)</el-checkbox>
        <p></p>
        <div v-if="!reviewSubmitDatas.reviewItem5.radioSelect1">
          <div v-if="!reviewSubmitDatas.reviewItem5.radioSelect3">
            <el-radio style="font-weight: bold" v-model="reviewSubmitDatas.reviewItem5.radioSelect4"
              :label="0">按照《危险废物规范化管理指标体系》（环办〔2011〕48
              号）开展危险废物规范化管理考核</el-radio>

            <br />
            <el-radio-group :disabled="reviewSubmitDatas.reviewItem5.radioSelect4 == 1"
              v-model="reviewSubmitDatas.reviewItem5.radioSelect2" class="radioDiv">
              <div> <el-radio :label="1">完全达标（5.5分）</el-radio></div>
              <div> <el-radio :label="2">基本达标（3分）</el-radio></div>
              <div> <el-radio :label="3">不达标（0分）</el-radio></div>
            </el-radio-group>
            <p></p>

            <el-radio style="font-weight: bold" v-model="reviewSubmitDatas.reviewItem5.radioSelect4"
              :label="1">未开展危险废物规范化管理考核的</el-radio>
            <br />

            <el-checkbox-group :disabled="reviewSubmitDatas.reviewItem5.radioSelect4 == 0"
              v-model="reviewSubmitDatas.reviewItem5.selectedOptions">
              <!-- <p>未开展危险废物规范化管理考核的</p> -->
              <el-checkbox label="1">按要求申报登记（1分）</el-checkbox><br />
              <el-checkbox label="2">按要求规范管理、贮存（2分）</el-checkbox><br />
              <el-checkbox label="3">按要求转移处置（2.5分）</el-checkbox>
            </el-checkbox-group>
          </div>

          <p></p>
          <el-checkbox v-model="reviewSubmitDatas.reviewItem5.radioSelect3">非法排放、倾倒、处置危险废物等违法行为，存在任意一种情形的（0分）
          </el-checkbox>
        </div>
        <template v-if="!reviewSubmitDatas.reviewItem5.radioSelect1 &&
          !reviewSubmitDatas.reviewItem5.radioSelect3
          ">
          <div v-if="reviewSubmitDatas.reviewItem5.radioSelect4 == 0">
            <p class="fileText"></p>
            <label>附件（考核表）: </label>
            <span style="color: blue; cursor: pointer" @click="
              checkFile(reviewSubmitDatas.reviewItem5.fileObj1.filePath)
              " v-if="reviewSubmitDatas.reviewItem5.fileObj1.filePath">{{
    getFileName(reviewSubmitDatas.reviewItem5.fileObj1.filePath)
  }}</span>
            <input v-else type="file" accept=".pdf,image/*" objName="reviewItem5" filePathKey="fileObj1" senum="5"
              value="" @change="handleUpload" />
            <button v-if="reviewSubmitDatas.reviewItem5.fileObj1.filePath"
              @click="reviewSubmitDatas.reviewItem5.fileObj1.filePath = ''">
              重新上传
            </button>
          </div>
          <div v-if="reviewSubmitDatas.reviewItem5.radioSelect4 == 1">
            <template v-if="reviewSubmitDatas.reviewItem5.selectedOptions.includes('1')">
              <p class="fileText"></p>
              <label>附件(申报登记): </label>
              <span style="color: blue; cursor: pointer" @click="
                checkFile(reviewSubmitDatas.reviewItem5.fileObj2.filePath)
                " v-if="reviewSubmitDatas.reviewItem5.fileObj2.filePath">{{
    getFileName(reviewSubmitDatas.reviewItem5.fileObj2.filePath)
  }}</span>
              <input v-else type="file" accept=".pdf,image/*" objName="reviewItem5" filePathKey="fileObj2" senum="5"
                value="" @change="handleUpload" />
              <button v-if="reviewSubmitDatas.reviewItem5.fileObj2.filePath"
                @click="reviewSubmitDatas.reviewItem5.fileObj2.filePath = ''">
                重新上传
              </button>
            </template>
            <template v-if="reviewSubmitDatas.reviewItem5.selectedOptions.includes('2')">
              <p class="fileText"></p>
              <label>附件(规范管理，贮存): </label>
              <span style="color: blue; cursor: pointer" @click="
                checkFile(reviewSubmitDatas.reviewItem5.fileObj3.filePath)
                " v-if="reviewSubmitDatas.reviewItem5.fileObj3.filePath">{{
    getFileName(reviewSubmitDatas.reviewItem5.fileObj3.filePath)
  }}</span>
              <input v-else type="file" accept=".pdf,image/*" objName="reviewItem5" filePathKey="fileObj3" senum="5"
                value="" @change="handleUpload" />
              <button v-if="reviewSubmitDatas.reviewItem5.fileObj3.filePath"
                @click="reviewSubmitDatas.reviewItem5.fileObj3.filePath = ''">
                重新上传
              </button>
            </template>
            <template v-if="reviewSubmitDatas.reviewItem5.selectedOptions.includes('3')">
              <p class="fileText"></p>
              <label>附件(转移处置): </label>
              <span style="color: blue; cursor: pointer" @click="
                checkFile(reviewSubmitDatas.reviewItem5.fileObj4.filePath)
                " v-if="reviewSubmitDatas.reviewItem5.fileObj4.filePath">{{
    getFileName(reviewSubmitDatas.reviewItem5.fileObj4.filePath)
  }}</span>
              <input v-else type="file" accept=".pdf,image/*" objName="reviewItem5" filePathKey="fileObj4" senum="5"
                value="" @change="handleUpload" />
              <button v-if="reviewSubmitDatas.reviewItem5.fileObj4.filePath"
                @click="reviewSubmitDatas.reviewItem5.fileObj4.filePath = ''">
                重新上传
              </button>
            </template>
          </div>
        </template>

        <template v-else-if="reviewSubmitDatas.reviewItem5.radioSelect1">
          <p class="fileText"></p>
          <label>附件（情况说明）: </label>
          <span style="color: blue; cursor: pointer" @click="checkFile(reviewSubmitDatas.reviewItem5.fileObj1.filePath)"
            v-if="reviewSubmitDatas.reviewItem5.fileObj1.filePath">{{
              getFileName(reviewSubmitDatas.reviewItem5.fileObj1.filePath)
            }}</span>
          <input v-else type="file" accept=".pdf,image/*" objName="reviewItem5" filePathKey="fileObj1" senum="5" value=""
            @change="handleUpload" />
          <button v-if="reviewSubmitDatas.reviewItem5.fileObj1.filePath"
            @click="reviewSubmitDatas.reviewItem5.fileObj1.filePath = ''">
            重新上传
          </button>
        </template>
        <template v-if="reviewSubmitDatas.reviewItem5.radioSelect3 &&
          !reviewSubmitDatas.reviewItem5.radioSelect1
          ">
          <p class="fileText"></p>
          <label>附件（情况说明）: </label>
          <span style="color: blue; cursor: pointer" @click="checkFile(reviewSubmitDatas.reviewItem5.fileObj1.filePath)"
            v-if="reviewSubmitDatas.reviewItem5.fileObj1.filePath">{{
              getFileName(reviewSubmitDatas.reviewItem5.fileObj1.filePath)
            }}</span>
          <input v-else type="file" accept=".pdf,image/*" objName="reviewItem5" filePathKey="fileObj1" senum="5" value=""
            @change="handleUpload" />
          <button v-if="reviewSubmitDatas.reviewItem5.fileObj1.filePath"
            @click="reviewSubmitDatas.reviewItem5.fileObj1.filePath = ''">
            重新上传
          </button>
        </template>
        <p></p>

        <br />
        <div class="button-container">
          <p>
            得分值：<span>{{ reviewSubmitDatas.reviewItem5.score }}</span>
          </p>
          <el-button type='primary' :disabled="!editable"
            @click="saveData({ path: 'Div5Save', itemPath: 'reviewItem5' })">
            保存</el-button>
        </div>
      </el-collapse-item>

      <el-collapse-item title="6、固体废物利用处置【企业自评与填报】" name="9">
        <template #title>
          <span style="color: #dc6731; font-weight: bold">6、固体废物利用处置【企业自评与填报】</span>
        </template>
        <span style="padding-right: 6px">企业说明</span>
        <el-input style="width: 800px" type="textarea" autosize placeholder="请输入内容"
          v-model="reviewSubmitDatas.reviewItem6.remark"></el-input>
        <el-image style="
            height: 150px;
            width: 267px;
            float: right;
            margin: 20px 80px 20px 0px;
          " :src="require('../../assets/images/guizhouReviewHints/guizhouHints_6.jpg')
            " :preview-src-list="[
    require('../../assets/images/guizhouReviewHints/guizhouHints_6.jpg'),
  ]">
        </el-image>
        <p></p>
        <el-radio-group class="radioDiv" v-model="reviewSubmitDatas.reviewItem6.radioSelect">
          <div>
            <el-radio :label="1">固体废物平均利用、处置率≥90%（3分）</el-radio>
          </div>

          <div> <el-radio :label="2">80%≤固体废物平均利用、处置率＜90%（2分）</el-radio></div>
          <div> <el-radio :label="3">60%≤固体废物平均利用、处置率＜80%（1分）</el-radio></div>
          <div> <el-radio :label="4">固体废物平均利用、处置率＜60%（0分）</el-radio></div>
        </el-radio-group>
        <p class="fileText"></p>
        <label>附件（台账、合同等）: </label>
        <span style="color: blue; cursor: pointer" @click="checkFile(reviewSubmitDatas.reviewItem6.fileObj.filePath)"
          v-if="reviewSubmitDatas.reviewItem6.fileObj.filePath">{{
            getFileName(reviewSubmitDatas.reviewItem6.fileObj.filePath)
          }}</span>
        <input v-else type="file" accept=".pdf,image/*" objName="reviewItem6" filePathKey="fileObj" senum="6" value=""
          @change="handleUpload" />
        <button v-if="reviewSubmitDatas.reviewItem6.fileObj.filePath"
          @click="reviewSubmitDatas.reviewItem6.fileObj.filePath = ''">
          重新上传
        </button>

        <p></p>
        <br />
        <div class="button-container">
          <p>
            得分值：<span>{{ reviewSubmitDatas.reviewItem6.score }}</span>
          </p>
          <el-button type='primary' :disabled="!editable"
            @click="saveData({ path: 'Div6Save', itemPath: 'reviewItem6' })">
            保存</el-button>
        </div>
      </el-collapse-item>
      <el-collapse-item title="7、污染治理设施运行【企业自评与填报】" name="10">
        <template #title>
          <span style="color: #dc6731; font-weight: bold">7、污染治理设施运行【企业自评与填报】</span>
        </template>
        <span style="padding-right: 6px">企业说明</span>
        <el-input style="width: 800px" type="textarea" autosize placeholder="请输入内容"
          v-model="reviewSubmitDatas.reviewItem7.remark"></el-input>
        <el-image style="
            height: 150px;
            width: 267px;
            float: right;
            margin: 20px 80px 20px 0px;
          " :src="require('../../assets/images/guizhouReviewHints/guizhouHints_7.jpg')
            " :preview-src-list="[
    require('../../assets/images/guizhouReviewHints/guizhouHints_7.jpg'),
  ]">
        </el-image>
        <div v-if="!reviewSubmitDatas.reviewItem7.radioSelect3">
          <p></p>
          <el-radio-group class="radioDiv" v-model="reviewSubmitDatas.reviewItem7.radioSelect1">
            <div><el-radio :label="1">治污设施正常运转率≥95%（5分）</el-radio></div>
            <div> <el-radio :label="2">75%≤治污设施正常运转率＜95%（4分）</el-radio></div>
            <div> <el-radio :label="3">50%≤治污设施正常运转率＜75%（3分）</el-radio></div>
            <div> <el-radio :label="4">治污设施正常运转率＜50%（1分）</el-radio></div>
          </el-radio-group>
          <p></p>
          <el-checkbox v-model="reviewSubmitDatas.reviewItem7.radioSelect2">排放污染物的浓度与总量稳定达标排放（2分）
          </el-checkbox>
        </div>
        <p></p>
        <el-checkbox v-model="reviewSubmitDatas.reviewItem7.radioSelect3">存在故意不正常使用治污设施或擅自闲置、拆除治污设施的（0分）
        </el-checkbox>

        <p class="fileText"></p>
        <label>附件1（运行和维护）: </label>
        <span style="color: blue; cursor: pointer" @click="checkFile(reviewSubmitDatas.reviewItem7.fileObj1.filePath)"
          v-if="reviewSubmitDatas.reviewItem7.fileObj1.filePath">{{
            getFileName(reviewSubmitDatas.reviewItem7.fileObj1.filePath)
          }}</span>
        <input v-else type="file" accept=".pdf,image/*" objName="reviewItem7" filePathKey="fileObj1" senum="7" value=""
          @change="handleUpload" />
        <button v-if="reviewSubmitDatas.reviewItem7.fileObj1.filePath"
          @click="reviewSubmitDatas.reviewItem7.fileObj1.filePath = ''">
          重新上传
        </button>
        <template v-if="reviewSubmitDatas.reviewItem7.radioSelect2">
          <p class="fileText"></p>
          <label>附件2（浓度和总量）: </label>
          <span style="color: blue; cursor: pointer" @click="checkFile(reviewSubmitDatas.reviewItem7.fileObj2.filePath)"
            v-if="reviewSubmitDatas.reviewItem7.fileObj2.filePath">{{
              getFileName(reviewSubmitDatas.reviewItem7.fileObj2.filePath)
            }}</span>
          <input v-else type="file" accept=".pdf,image/*" objName="reviewItem7" filePathKey="fileObj2" senum="7" value=""
            @change="handleUpload" />
          <button v-if="reviewSubmitDatas.reviewItem7.fileObj2.filePath"
            @click="reviewSubmitDatas.reviewItem7.fileObj2.filePath = ''">
            重新上传
          </button>
        </template>
        <p></p>
        <br />
        <div class="button-container">
          <p>
            得分值：<span>{{ reviewSubmitDatas.reviewItem7.score }}</span>
          </p>
          <el-button type='primary' :disabled="!editable"
            @click="saveData({ path: 'Div7Save', itemPath: 'reviewItem7' })">
            保存</el-button>
        </div>
      </el-collapse-item>
      <el-collapse-item title="8、排污申报【企业自评与填报】" name="11">
        <template #title>
          <span style="color: #dc6731; font-weight: bold">8、排污申报【企业自评与填报】</span>
        </template>
        <span style="padding-right: 6px">企业说明</span>
        <el-input style="width: 800px" type="textarea" autosize placeholder="请输入内容"
          v-model="reviewSubmitDatas.reviewItem8.remark"></el-input>
        <el-image style="
            height: 150px;
            width: 267px;
            float: right;
            margin: 20px 80px 20px 0px;
          " :src="require('../../assets/images/guizhouReviewHints/guizhouHints_8.jpg')
            " :preview-src-list="[
    require('../../assets/images/guizhouReviewHints/guizhouHints_8.jpg'),
  ]">
        </el-image>
        <p></p>
        <el-radio-group v-model="reviewSubmitDatas.reviewItem8.radioSelect" class="radioDiv">
          <div><el-radio :label="1">按规定进行排污申报（2分）</el-radio></div>
          <div> <el-radio :label="2">未按规定进行排污申报（0分）</el-radio></div>
        </el-radio-group>
        <p class="fileText"></p>
        <label>附件（申报资料）: </label>
        <span style="color: blue; cursor: pointer" @click="checkFile(reviewSubmitDatas.reviewItem8.fileObj.filePath)"
          v-if="reviewSubmitDatas.reviewItem8.fileObj.filePath">{{
            getFileName(reviewSubmitDatas.reviewItem8.fileObj.filePath)
          }}</span>
        <input v-else type="file" accept=".pdf,image/*" objName="reviewItem8" filePathKey="fileObj" senum="8" value=""
          @change="handleUpload" />
        <button v-if="reviewSubmitDatas.reviewItem8.fileObj.filePath"
          @click="reviewSubmitDatas.reviewItem8.fileObj.filePath = ''">
          重新上传
        </button>

        <p></p>
        <div class="button-container">
          <p>
            得分值：<span>{{ reviewSubmitDatas.reviewItem8.score }}</span>
          </p>
          <el-button type='primary' :disabled="!editable"
            @click="saveData({ path: 'Div8Save', itemPath: 'reviewItem8' })">
            保存</el-button>
        </div>
      </el-collapse-item>
      <el-collapse-item title="9、依法缴纳排污费或环保税【企业自评与填报】" name="12">
        <template #title>
          <span style="color: #dc6731; font-weight: bold">9、依法缴纳排污费或环保税【企业自评与填报】</span>
        </template>
        <span style="padding-right: 6px">企业说明</span>
        <el-input style="width: 800px" type="textarea" autosize placeholder="请输入内容"
          v-model="reviewSubmitDatas.reviewItem9.remark"></el-input>
        <el-image style="
            height: 150px;
            width: 267px;
            float: right;
            margin: 20px 80px 20px 0px;
          " :src="require('../../assets/images/guizhouReviewHints/guizhouHints_9.jpg')
            " :preview-src-list="[
    require('../../assets/images/guizhouReviewHints/guizhouHints_9.jpg'),
  ]">
        </el-image>
        <p></p>
        <el-radio-group v-model="reviewSubmitDatas.reviewItem9.radioSelect" class="radioDiv">
          <div> <el-radio :label="1">按规定足额缴纳（2分）</el-radio></div>
          <div> <el-radio :label="2">未按规定足额缴纳（0分）</el-radio></div>
        </el-radio-group>
        <p class="fileText"></p>
        <label>附件（环保税资料）: </label>
        <span style="color: blue; cursor: pointer" @click="checkFile(reviewSubmitDatas.reviewItem9.fileObj.filePath)"
          v-if="reviewSubmitDatas.reviewItem9.fileObj.filePath">{{
            getFileName(reviewSubmitDatas.reviewItem9.fileObj.filePath)
          }}</span>
        <input v-else type="file" accept=".pdf,image/*" objName="reviewItem9" filePathKey="fileObj" senum="9" value=""
          @change="handleUpload" />
        <button v-if="reviewSubmitDatas.reviewItem9.fileObj.filePath"
          @click="reviewSubmitDatas.reviewItem9.fileObj.filePath = ''">
          重新上传
        </button>
        <p></p>
        <div class="button-container">
          <p>
            得分值：<span>{{ reviewSubmitDatas.reviewItem9.score }}</span>
          </p>
          <el-button type='primary' :disabled="!editable"
            @click="saveData({ path: 'Div9Save', itemPath: 'reviewItem9' })">
            保存</el-button>
        </div>
      </el-collapse-item>
      <el-collapse-item title="10、排污口规范【企业自评与填报】" name="13">
        <template #title>
          <span style="color: #dc6731; font-weight: bold">10、排污口规范【企业自评与填报】</span>
        </template>
        <span style="padding-right: 6px">企业说明</span>
        <el-input style="width: 800px" type="textarea" autosize placeholder="请输入内容"
          v-model="reviewSubmitDatas.reviewItem10.remark"></el-input>
        <el-image style="
            height: 150px;
            width: 267px;
            float: right;
            margin: 20px 80px 20px 0px;
          " :src="require('../../assets/images/guizhouReviewHints/guizhouHints_10.jpg')
            " :preview-src-list="[
    require('../../assets/images/guizhouReviewHints/guizhouHints_10.jpg'),
  ]">
        </el-image>
        <p></p>
        <el-radio-group v-model="reviewSubmitDatas.reviewItem10.radioSelect" class="radioDiv">
          <div> <el-radio :label="1">企业的排污口设置符合规范要求（2分）</el-radio></div>
          <div> <el-radio :label="2">企业的排污口设置不符合规范要求（0分）</el-radio></div>
        </el-radio-group>
        <p class="fileText"></p>
        <label>附件（排污口资料）: </label>
        <span style="color: blue; cursor: pointer" @click="checkFile(reviewSubmitDatas.reviewItem10.fileObj.filePath)"
          v-if="reviewSubmitDatas.reviewItem10.fileObj.filePath">{{
            getFileName(reviewSubmitDatas.reviewItem10.fileObj.filePath)
          }}</span>
        <input v-else type="file" accept=".pdf,image/*" objName="reviewItem10" filePathKey="fileObj" senum="10" value=""
          @change="handleUpload" />
        <button v-if="reviewSubmitDatas.reviewItem10.fileObj.filePath"
          @click="reviewSubmitDatas.reviewItem10.fileObj.filePath = ''">
          重新上传
        </button>

        <p></p>
        <div class="button-container">
          <p>
            得分值：<span>{{ reviewSubmitDatas.reviewItem10.score }}</span>
          </p>
          <el-button type='primary' :disabled="!editable"
            @click="saveData({ path: 'Div10Save', itemPath: 'reviewItem10' })">保存</el-button>
        </div>
      </el-collapse-item>
      <el-collapse-item title="11、建设项目环评审批及“三同时”制度执行情况【企业自评与填报】" name="14">
        <template #title>
          <span style="color: #dc6731; font-weight: bold">11、建设项目环评审批及“三同时”制度执行情况【企业自评与填报】</span>
        </template>
        <span style="padding-right: 6px">企业说明</span>
        <el-input style="width: 800px" type="textarea" autosize placeholder="请输入内容"
          v-model="reviewSubmitDatas.reviewItem11.remark"></el-input>
        <el-image style="
            height: 150px;
            width: 267px;
            float: right;
            margin: 20px 80px 20px 0px;
          " :src="require('../../assets/images/guizhouReviewHints/guizhouHints_11.jpg')
            " :preview-src-list="[
    require('../../assets/images/guizhouReviewHints/guizhouHints_11.jpg'),
  ]">
        </el-image>
        <p></p>
        <el-checkbox v-model="reviewSubmitDatas.reviewItem11.radioSelect3">环境影响评价审批文件
        </el-checkbox>
        <p></p>
        <div v-if="reviewSubmitDatas.reviewItem11.radioSelect3">
          <p></p>
          <el-radio-group v-model="reviewSubmitDatas.reviewItem11.radioSelect1" class="radioDiv">
            <div> <el-radio :label="1">依法按程序取得环境影响评价审批文件（4分）</el-radio></div>
            <div> <el-radio :label="2">未依法按程序取得环境影响评价审批文件（0分）</el-radio></div>
          </el-radio-group>
        </div>
        <el-checkbox v-model="reviewSubmitDatas.reviewItem11.radioSelect4">建设项目环保“三同时”制度
        </el-checkbox>
        <p></p>
        <div v-if="reviewSubmitDatas.reviewItem11.radioSelect4">
          <el-radio-group v-model="reviewSubmitDatas.reviewItem11.radioSelect2" class="radioDiv">
            <div> <el-radio :label="1">严格执行建设项目环保“三同时”制度（4分）</el-radio></div>
            <div> <el-radio :label="2">未执行建设项目环保“三同时”制度（0分）</el-radio></div>
          </el-radio-group>
          <p></p>
        </div>
        <div v-if="reviewSubmitDatas.reviewItem11.radioSelect3">
          <p class="fileText"></p>
          <label>附件（环评全本、批复等）: </label>
          <span style="color: blue; cursor: pointer" @click="checkFile(reviewSubmitDatas.reviewItem11.fileObj1.filePath)"
            v-if="reviewSubmitDatas.reviewItem11.fileObj1.filePath">{{
              getFileName(reviewSubmitDatas.reviewItem11.fileObj1.filePath)
            }}</span>
          <input v-else type="file" accept=".pdf,image/*" objName="reviewItem11" filePathKey="fileObj1" senum="11"
            value="" @change="handleUpload" />
          <button v-if="reviewSubmitDatas.reviewItem11.fileObj1.filePath"
            @click="reviewSubmitDatas.reviewItem11.fileObj1.filePath = ''">
            重新上传
          </button>

          <br />
        </div>
        <div v-if="reviewSubmitDatas.reviewItem11.radioSelect4">
          <p class="fileText"></p>
          <label>附件（三同时、验收等）: </label>
          <span style="color: blue; cursor: pointer" @click="checkFile(reviewSubmitDatas.reviewItem11.fileObj2.filePath)"
            v-if="reviewSubmitDatas.reviewItem11.fileObj2.filePath">{{
              getFileName(reviewSubmitDatas.reviewItem11.fileObj2.filePath)
            }}</span>
          <input v-else type="file" accept=".pdf,image/*" objName="reviewItem11" filePathKey="fileObj2" senum="11"
            value="" @change="handleUpload" />
          <button v-if="reviewSubmitDatas.reviewItem11.fileObj2.filePath"
            @click="reviewSubmitDatas.reviewItem11.fileObj2.filePath = ''">
            重新上传
          </button>

          <br />
        </div>

        <p></p>

        <div class="button-container">
          <p>
            得分值：<span>{{ reviewSubmitDatas.reviewItem11.score }}</span>
          </p>
          <el-button type='primary' :disabled="!editable"
            @click="saveData({ path: 'Div11Save', itemPath: 'reviewItem11' })">保存</el-button>
        </div>
      </el-collapse-item>

      <el-collapse-item title="12、企业环境保护责任制度落实（环保机构、人员、制度等）【企业自评与填报】" name="15">
        <template #title>
          <span style="color: #dc6731; font-weight: bold">12、企业环境保护责任制度落实（环保机构、人员、制度等）【企业自评与填报】</span>
        </template>
        <span style="padding-right: 6px">企业说明</span>
        <el-input style="width: 800px" type="textarea" autosize placeholder="请输入内容"
          v-model="reviewSubmitDatas.reviewItem12.remark"></el-input>
        <el-image style="
            height: 150px;
            width: 267px;
            float: right;
            margin: 20px 80px 20px 0px;
          " :src="require('../../assets/images/guizhouReviewHints/guizhouHints_12.jpg')
            " :preview-src-list="[
    require('../../assets/images/guizhouReviewHints/guizhouHints_12.jpg'),
  ]">
        </el-image>
        <p></p>
        <el-radio-group class="radioDiv" v-model="reviewSubmitDatas.reviewItem12.radioSelect">
          <div> <el-radio :label="1">有专职环保机构和人员（2分）</el-radio></div>
          <div> <el-radio :label="2">有兼职环保机构和人员（1分）</el-radio></div>
          <div> <el-radio :label="3">无环保机构和人员（0分）</el-radio></div>
        </el-radio-group>
        <p>有满足企业环境管理需要的相应制度（1分/项，最高2分）</p>
        <el-checkbox-group :max="2" v-model="reviewSubmitDatas.reviewItem12.selectedOptions">
          <el-checkbox label="1">环保岗位责任制度(1分)</el-checkbox>
          <br />
          <el-checkbox label="2">环保设施运行管理制度(1分)</el-checkbox>
          <br />
          <el-checkbox label="3">环保信用报告制度(1分)</el-checkbox>
          <br />
          <el-checkbox label="4">环保档案管理制度等(1分)</el-checkbox>
        </el-checkbox-group>

        <p class="fileText"></p>
        <label>附件(环保机构和人员): </label>
        <span style="color: blue; cursor: pointer" @click="checkFile(reviewSubmitDatas.reviewItem12.fileObj1.filePath)"
          v-if="reviewSubmitDatas.reviewItem12.fileObj1.filePath">{{
            getFileName(reviewSubmitDatas.reviewItem12.fileObj1.filePath)
          }}</span>
        <input v-else type="file" accept=".pdf,image/*" objName="reviewItem12" filePathKey="fileObj1" senum="12" value=""
          @change="handleUpload" />
        <button v-if="reviewSubmitDatas.reviewItem12.fileObj1.filePath"
          @click="reviewSubmitDatas.reviewItem12.fileObj1.filePath = ''">
          重新上传
        </button>

        <div v-if="reviewSubmitDatas.reviewItem12.selectedOptions.length >= 1">
          <p class="fileText"></p>
          <label>附件(制度1): </label>
          <span style="color: blue; cursor: pointer" @click="checkFile(reviewSubmitDatas.reviewItem12.fileObj2.filePath)"
            v-if="reviewSubmitDatas.reviewItem12.fileObj2.filePath">{{
              getFileName(reviewSubmitDatas.reviewItem12.fileObj2.filePath)
            }}</span>
          <input v-else type="file" accept=".pdf,image/*" objName="reviewItem12" filePathKey="fileObj2" senum="12"
            value="" @change="handleUpload" />
          <button v-if="reviewSubmitDatas.reviewItem12.fileObj2.filePath"
            @click="reviewSubmitDatas.reviewItem12.fileObj2.filePath = ''">
            重新上传
          </button>
        </div>

        <div v-if="reviewSubmitDatas.reviewItem12.selectedOptions.length >= 2">
          <p class="fileText"></p>
          <label>附件(制度2): </label>
          <span style="color: blue; cursor: pointer" @click="checkFile(reviewSubmitDatas.reviewItem12.fileObj3.filePath)"
            v-if="reviewSubmitDatas.reviewItem12.fileObj3.filePath">{{
              getFileName(reviewSubmitDatas.reviewItem12.fileObj3.filePath)
            }}</span>
          <input v-else type="file" accept=".pdf,image/*" objName="reviewItem12" filePathKey="fileObj3" senum="12"
            value="" @change="handleUpload" />
          <button v-if="reviewSubmitDatas.reviewItem12.fileObj3.filePath"
            @click="reviewSubmitDatas.reviewItem12.fileObj3.filePath = ''">
            重新上传
          </button>
        </div>

        <!-- <p></p>
				<label>附件4: </label>
				<span style="color: blue; cursor: pointer"
					@click="checkFile(reviewSubmitDatas.reviewItem12.fileObj4.filePath)"
					v-if="reviewSubmitDatas.reviewItem12.fileObj4.filePath">{{ getFileName(reviewSubmitDatas.reviewItem12.fileObj4.filePath) }}</span>
				<input v-else  type="file"
                accept=".pdf,image/*" objName="reviewItem12" filePathKey="fileObj4" senum="2" value=""
					@change="handleUpload" />
				<button v-if="reviewSubmitDatas.reviewItem12.fileObj4.filePath"
					@click="reviewSubmitDatas.reviewItem12.fileObj4.filePath=''">重新上传</button>



			<p class="fileText"></p>
				<label>附件5: </label>
				<span style="color: blue; cursor: pointer"
					@click="checkFile(reviewSubmitDatas.reviewItem12.fileObj5.filePath)"
					v-if="reviewSubmitDatas.reviewItem12.fileObj5.filePath">{{ getFileName(reviewSubmitDatas.reviewItem12.fileObj5.filePath) }}</span>
				<input v-else  type="file"
                accept=".pdf,image/*" objName="reviewItem12" filePathKey="fileObj5" senum="2" value=""
					@change="handleUpload" />
				<button v-if="reviewSubmitDatas.reviewItem12.fileObj5.filePath"
					@click="reviewSubmitDatas.reviewItem12.fileObj5.filePath=''">重新上传</button>

 -->

        <p></p>
        <div class="button-container">
          <p>
            得分值：<span>{{ reviewSubmitDatas.reviewItem12.score }}</span>
          </p>
          <el-button type='primary' :disabled="!editable"
            @click="saveData({ path: 'Div12Save', itemPath: 'reviewItem12' })">保存</el-button>
        </div>
      </el-collapse-item>
      <el-collapse-item title="13、环境风险管理【企业自评与填报】" name="16">
        <template #title>
          <span style="color: #dc6731; font-weight: bold">13、环境风险管理【企业自评与填报】</span>
        </template>
        <span style="padding-right: 6px">企业说明</span>
        <el-input style="width: 800px" type="textarea" autosize placeholder="请输入内容"
          v-model="reviewSubmitDatas.reviewItem13.remark"></el-input>
        <el-image style="
            height: 150px;
            width: 267px;
            float: right;
            margin: 20px 80px 20px 0px;
          " :src="require('../../assets/images/guizhouReviewHints/guizhouHints_13.jpg')
            " :preview-src-list="[
    require('../../assets/images/guizhouReviewHints/guizhouHints_13.jpg'),
  ]">
        </el-image>
        <p></p>
        <el-checkbox v-model="reviewSubmitDatas.reviewItem13.radioSelect">无环境风险管理要求(3分)</el-checkbox>
        <p></p>
        <el-checkbox-group v-if="!reviewSubmitDatas.reviewItem13.radioSelect"
          v-model="reviewSubmitDatas.reviewItem13.selectedOptions">
          <el-checkbox label="1">按要求编制应急预案并进行备案(1分)</el-checkbox>
          <br />
          <el-checkbox label="2">按要求开展风险隐患排查(1分)</el-checkbox>
          <br />
          <el-checkbox label="3">定期组织应急演练(1分)</el-checkbox>
        </el-checkbox-group>
        <p class="fileText"></p>
        <template v-if="reviewSubmitDatas.reviewItem13.radioSelect ||
          reviewSubmitDatas.reviewItem13.selectedOptions.includes('1')
          ">
          <label>附件1（情况说明或预案全本及备案表）: </label>
          <span style="color: blue; cursor: pointer" @click="checkFile(reviewSubmitDatas.reviewItem13.fileObj1.filePath)"
            v-if="reviewSubmitDatas.reviewItem13.fileObj1.filePath">{{
              getFileName(reviewSubmitDatas.reviewItem13.fileObj1.filePath)
            }}</span>
          <input v-else type="file" accept=".pdf,image/*" objName="reviewItem13" filePathKey="fileObj1" senum="13"
            value="" @change="handleUpload" />
          <button v-if="reviewSubmitDatas.reviewItem13.fileObj1.filePath"
            @click="reviewSubmitDatas.reviewItem13.fileObj1.filePath = ''">
            重新上传
          </button>
          <br />
        </template>

        <template v-if="!reviewSubmitDatas.reviewItem13.radioSelect">
          <div v-if="reviewSubmitDatas.reviewItem13.selectedOptions.includes('2')">
            <label>附件2（排查台账）: </label>
            <span style="color: blue; cursor: pointer" @click="
              checkFile(reviewSubmitDatas.reviewItem13.fileObj2.filePath)
              " v-if="reviewSubmitDatas.reviewItem13.fileObj2.filePath">{{
    getFileName(reviewSubmitDatas.reviewItem13.fileObj2.filePath)
  }}</span>
            <input v-else type="file" accept=".pdf,image/*" objName="reviewItem13" filePathKey="fileObj2" senum="13"
              value="" @change="handleUpload" />
            <button v-if="reviewSubmitDatas.reviewItem13.fileObj2.filePath"
              @click="reviewSubmitDatas.reviewItem13.fileObj2.filePath = ''">
              重新上传
            </button>
          </div>
          <div v-if="reviewSubmitDatas.reviewItem13.selectedOptions.includes('3')">
            <label>附件3（方案、照片等）: </label>
            <span style="color: blue; cursor: pointer" @click="
              checkFile(reviewSubmitDatas.reviewItem13.fileObj3.filePath)
              " v-if="reviewSubmitDatas.reviewItem13.fileObj3.filePath">
              {{
                getFileName(reviewSubmitDatas.reviewItem13.fileObj3.filePath)
              }}</span>
            <input v-else type="file" accept=".pdf,image/*" objName="reviewItem13" filePathKey="fileObj3" senum="13"
              value="" @change="handleUpload" />
            <button v-if="reviewSubmitDatas.reviewItem13.fileObj3.filePath"
              @click="reviewSubmitDatas.reviewItem13.fileObj3.filePath = ''">
              重新上传
            </button>
          </div>
        </template>

        <br />

        <p></p>
        <div class="button-container">
          <p>
            得分值：<span>{{ reviewSubmitDatas.reviewItem13.score }}</span>
          </p>
          <el-button type='primary' :disabled="!editable"
            @click="saveData({ path: 'Div13Save', itemPath: 'reviewItem13' })">保存</el-button>
        </div>
      </el-collapse-item>
      <el-collapse-item title="14、环境统计填报【企业自评与填报】" name="17">
        <template #title>
          <span style="color: #dc6731; font-weight: bold">14、环境统计填报【企业自评与填报】</span>
        </template>
        <span style="padding-right: 6px">企业说明</span>
        <el-input style="width: 800px" type="textarea" autosize placeholder="请输入内容"
          v-model="reviewSubmitDatas.reviewItem14.remark"></el-input>
        <el-image style="
            height: 150px;
            width: 267px;
            float: right;
            margin: 20px 80px 20px 0px;
          " :src="require('../../assets/images/guizhouReviewHints/guizhouHints_14.jpg')
            " :preview-src-list="[
    require('../../assets/images/guizhouReviewHints/guizhouHints_14.jpg'),
  ]">
        </el-image>
        <p></p>
        <el-radio-group class="radioDiv" v-model="reviewSubmitDatas.reviewItem14.radioSelect">
          <div> <el-radio :label="1">按期、如实填报环境统计信息或无环境统计填报要求（2分）</el-radio></div>
          <div><el-radio :label="2">未按期或不如实填报环境统计信息（0分）</el-radio></div>
        </el-radio-group>
        <p class="fileText"></p>
        <label>附件（环统）: </label>
        <span style="color: blue; cursor: pointer" @click="checkFile(reviewSubmitDatas.reviewItem14.fileObj.filePath)"
          v-if="reviewSubmitDatas.reviewItem14.fileObj.filePath">{{
            getFileName(reviewSubmitDatas.reviewItem14.fileObj.filePath)
          }}</span>
        <input v-else type="file" accept=".pdf,image/*" objName="reviewItem14" filePathKey="fileObj" senum="14" value=""
          @change="handleUpload" />
        <button v-if="reviewSubmitDatas.reviewItem14.fileObj.filePath"
          @click="reviewSubmitDatas.reviewItem14.fileObj.filePath = ''">
          重新上传
        </button>

        <p></p>
        <div class="button-container">
          <p>
            得分值：<span>{{ reviewSubmitDatas.reviewItem14.score }}</span>
          </p>
          <el-button type='primary' :disabled="!editable"
            @click="saveData({ path: 'Div14Save', itemPath: 'reviewItem14' })">保存</el-button>
        </div>
      </el-collapse-item>

      <el-collapse-item title="15、环境信息公开【企业自评与填报】" name="18">
        <template #title>
          <span style="color: #dc6731; font-weight: bold">15、环境信息公开【企业自评与填报】</span>
        </template>
        <span style="padding-right: 6px">企业说明</span>
        <el-input style="width: 800px" type="textarea" autosize placeholder="请输入内容"
          v-model="reviewSubmitDatas.reviewItem15.remark"></el-input>
        <el-image style="
            height: 150px;
            width: 267px;
            float: right;
            margin: 20px 80px 20px 0px;
          " :src="require('../../assets/images/guizhouReviewHints/guizhouHints_15.jpg')
            " :preview-src-list="[
    require('../../assets/images/guizhouReviewHints/guizhouHints_15.jpg'),
  ]">
        </el-image>
        <p></p>
        <el-radio-group class="radioDiv" v-model="reviewSubmitDatas.reviewItem15.radioSelect">
          <div><el-radio :label="1">依法公开且公开内容符合规定要求（3分）</el-radio></div>
          <div> <el-radio :label="2">公开内容不符合规定要求（2分）</el-radio></div>
          <div> <el-radio :label="3">公开内容弄虚作假、或依法应公开但拒不公开环境信息（0分）</el-radio></div>
        </el-radio-group>
        <p class="fileText"></p>
        <label>附件（公开）: </label>
        <span style="color: blue; cursor: pointer" @click="checkFile(reviewSubmitDatas.reviewItem15.fileObj.filePath)"
          v-if="reviewSubmitDatas.reviewItem15.fileObj.filePath">{{
            getFileName(reviewSubmitDatas.reviewItem15.fileObj.filePath)
          }}</span>
        <input v-else type="file" accept=".pdf,image/*" objName="reviewItem15" filePathKey="fileObj" senum="15" value=""
          @change="handleUpload" />
        <button v-if="reviewSubmitDatas.reviewItem15.fileObj.filePath"
          @click="reviewSubmitDatas.reviewItem15.fileObj.filePath = ''">
          重新上传
        </button>

        <p></p>
        <div class="button-container">
          <p>
            得分值：<span>{{ reviewSubmitDatas.reviewItem15.score }}</span>
          </p>
          <el-button type='primary' :disabled="!editable"
            @click="saveData({ path: 'Div15Save', itemPath: 'reviewItem15' })">保存</el-button>
        </div>
      </el-collapse-item>

      <el-collapse-item title="16、行政处罚【企业自评与填报】" name="19">
        <template #title>
          <span style="color: #dc6731; font-weight: bold">16、行政处罚【企业自评与填报】</span>
        </template>
        <span style="padding-right: 6px">企业说明</span>
        <el-input style="width: 800px" type="textarea" autosize placeholder=""
          v-model="reviewSubmitDatas.reviewItem16.remark"></el-input>
        <el-image style="
            height: 150px;
            width: 267px;
            float: right;
            margin: 20px 80px 20px 0px;
          " :src="require('../../assets/images/guizhouReviewHints/guizhouHints_16.jpg')
            " :preview-src-list="[
    require('../../assets/images/guizhouReviewHints/guizhouHints_16.jpg'),
  ]">
        </el-image>

        <p></p>
        <el-input-number :disabled="reviewSubmitDatas.reviewItem16.radioSelect != '0'"
          v-model="reviewSubmitDatas.reviewItem16.counter1" :min="0" label="次" size="mini">
        </el-input-number>
        <span>评价年度内因环境违法行为受到罚款处罚，且单次罚款金额＜10
          万（-1/次）</span>
        <br />
        <el-input-number :disabled="reviewSubmitDatas.reviewItem16.radioSelect != '0'"
          v-model="reviewSubmitDatas.reviewItem16.counter2" :min="0" label="次" size="mini">
        </el-input-number>
        <span>评价年度内因环境违法行为受到行政处罚，且 10 万≤单次罚款金额≤50
          万（-2/次）</span>
        <br />
        <el-input-number :disabled="reviewSubmitDatas.reviewItem16.radioSelect != '0'"
          v-model="reviewSubmitDatas.reviewItem16.counter3" :min="0" label="次" size="mini">
        </el-input-number>
        <span>评价年度内因环境违法行为受到行政处罚，且单次罚款金额＞50
          万（-4/次）</span>
        <br />

        <p></p>

        <el-radio-group class="radioDiv" v-model="reviewSubmitDatas.reviewItem16.radioSelect">
          <div> <el-radio :label="0">选中以上情形（根据次数扣分）</el-radio>
          </div>
          <div><el-radio :label="1">评价年度内存在逃避监管等其他严重违法行为受到行政拘留、吊销许可证、责令停产停业等行政处罚的（-8分）</el-radio></div>
          <div> <el-radio :label="2">评价年度内不履行行政处罚决定（-8分）</el-radio></div>
          <div> <el-radio :label="3">评价年度内无因环境违法行为受到行政处罚（0分）</el-radio></div>
        </el-radio-group>
        <p></p>
        <p class="fileText"></p>
        <label>附件: </label>
        <span style="color: blue; cursor: pointer" @click="checkFile(reviewSubmitDatas.reviewItem16.fileObj.filePath)"
          v-if="reviewSubmitDatas.reviewItem16.fileObj.filePath">{{
            getFileName(reviewSubmitDatas.reviewItem16.fileObj.filePath)
          }}</span>
        <input v-else type="file" accept=".pdf,image/*" objName="reviewItem16" filePathKey="fileObj" senum="16" value=""
          @change="handleUpload" />
        <button v-if="reviewSubmitDatas.reviewItem16.fileObj.filePath"
          @click="reviewSubmitDatas.reviewItem16.fileObj.filePath = ''">
          重新上传
        </button>

        <p></p>
        <div class="button-container">
          <p>
            得分值：<span>{{ reviewSubmitDatas.reviewItem16.score }}</span>
          </p>
          <el-button type='primary' :disabled="!editable"
            @click="saveData({ path: 'Div16Save', itemPath: 'reviewItem16' })">保存</el-button>
        </div>
      </el-collapse-item>

      <el-collapse-item title="17、行政命令【企业自评与填报】" name="20">
        <template #title>
          <span style="color: #dc6731; font-weight: bold">17、行政命令【企业自评与填报】</span>
        </template>
        <span style="padding-right: 6px">企业说明</span>
        <el-input style="width: 800px" type="textarea" autosize placeholder="请输入内容"
          v-model="reviewSubmitDatas.reviewItem17.remark"></el-input>
        <el-image style="
            height: 150px;
            width: 267px;
            float: right;
            margin: 20px 80px 20px 0px;
          " :src="require('../../assets/images/guizhouReviewHints/guizhouHints_17.jpg')
            " :preview-src-list="[
    require('../../assets/images/guizhouReviewHints/guizhouHints_17.jpg'),
  ]">
        </el-image>
        <p></p>

        <el-input-number :disabled="reviewSubmitDatas.reviewItem17.radioSelect != '0'"
          v-model="reviewSubmitDatas.reviewItem17.counter" :min="0" label="次" size="mini">
        </el-input-number><span>评价年度内因环境违法行为被责令改正，履行相关义务或按期完成整改（-1/次）</span>
        <p></p>
        <el-radio-group class="radioDiv" v-model="reviewSubmitDatas.reviewItem17.radioSelect">
          <div> <el-radio :label="0">选中以上情形（根据次数扣分）</el-radio></div>
          <div><el-radio :label="1">评评价年度内因环境违法行为被责令改正，未履行相关义务或未按期完成整改（-5分）</el-radio></div>
          <div> <el-radio :label="2">评价年度内无因环境违法行为受到行政命令（0分）</el-radio></div>
        </el-radio-group>

        <p class="fileText"></p>
        <label>附件: </label>
        <span style="color: blue; cursor: pointer" @click="checkFile(reviewSubmitDatas.reviewItem17.fileObj.filePath)"
          v-if="reviewSubmitDatas.reviewItem17.fileObj.filePath">{{
            getFileName(reviewSubmitDatas.reviewItem17.fileObj.filePath)
          }}</span>
        <input v-else type="file" accept=".pdf,image/*" objName="reviewItem17" filePathKey="fileObj" senum="17" value=""
          @change="handleUpload" />
        <button v-if="reviewSubmitDatas.reviewItem17.fileObj.filePath"
          @click="reviewSubmitDatas.reviewItem17.fileObj.filePath = ''">
          重新上传
        </button>

        <p></p>
        <div class="button-container">
          <p>
            得分值：<span>{{ reviewSubmitDatas.reviewItem17.score }}</span>
          </p>
          <el-button type='primary' :disabled="!editable"
            @click="saveData({ path: 'Div17Save', itemPath: 'reviewItem17' })">保存</el-button>
        </div>
      </el-collapse-item>
      <el-collapse-item title="18、挂牌督办【企业自评与填报】" name="21">
        <template #title>
          <span style="color: #dc6731; font-weight: bold">18、挂牌督办【企业自评与填报】</span>
        </template>
        <span style="padding-right: 6px">企业说明</span>
        <el-input style="width: 800px" type="textarea" autosize placeholder="请输入内容"
          v-model="reviewSubmitDatas.reviewItem18.remark"></el-input>
        <el-image style="
            height: 150px;
            width: 267px;
            float: right;
            margin: 20px 80px 20px 0px;
          " :src="require('../../assets/images/guizhouReviewHints/guizhouHints_18.jpg')
            " :preview-src-list="[
    require('../../assets/images/guizhouReviewHints/guizhouHints_18.jpg'),
  ]">
        </el-image>
        <p></p>
        <el-radio-group class="radioDiv" v-model="reviewSubmitDatas.reviewItem18.radioSelect">
          <div> <el-radio :label="1">评价年度内被市（州）级以上生态环境部门挂牌督办（-4分）</el-radio></div>
          <div> <el-radio :label="2">评价年度内无挂牌督办（0分）</el-radio></div>
        </el-radio-group>

        <p class="fileText"></p>
        <label>附件: </label>
        <span style="color: blue; cursor: pointer" @click="checkFile(reviewSubmitDatas.reviewItem18.fileObj.filePath)"
          v-if="reviewSubmitDatas.reviewItem18.fileObj.filePath">{{
            getFileName(reviewSubmitDatas.reviewItem18.fileObj.filePath)
          }}</span>
        <input v-else type="file" accept=".pdf,image/*" objName="reviewItem18" filePathKey="fileObj" senum="18" value=""
          @change="handleUpload" />
        <button v-if="reviewSubmitDatas.reviewItem18.fileObj.filePath"
          @click="reviewSubmitDatas.reviewItem18.fileObj.filePath = ''">
          重新上传
        </button>

        <p></p>
        <div class="button-container">
          <p>
            得分值：<span>{{ reviewSubmitDatas.reviewItem18.score }}</span>
          </p>
          <el-button type='primary' :disabled="!editable"
            @click="saveData({ path: 'Div18Save', itemPath: 'reviewItem18' })">保存</el-button>
        </div>
      </el-collapse-item>

      <el-collapse-item title="19、突发环境事件【企业自评与填报】" name="22">
        <template #title>
          <span style="color: #dc6731; font-weight: bold">19、突发环境事件【企业自评与填报】</span>
        </template>
        <span style="padding-right: 6px">企业说明</span>
        <el-input style="width: 800px" type="textarea" autosize placeholder="请输入内容"
          v-model="reviewSubmitDatas.reviewItem19.remark"></el-input>
        <el-image style="
            height: 150px;
            width: 267px;
            float: right;
            margin: 20px 80px 20px 0px;
          " :src="require('../../assets/images/guizhouReviewHints/guizhouHints_19.jpg')
            " :preview-src-list="[
    require('../../assets/images/guizhouReviewHints/guizhouHints_19.jpg'),
  ]">
        </el-image>
        <p>评价年度内取最严重的情形扣一次</p>
        <p></p>
        <el-radio-group class="radioDiv" v-model="reviewSubmitDatas.reviewItem19.radioSelect">
          <div> <el-radio :label="1">评价年度内发生一般突发环境事件（-4分）</el-radio></div>
          <div> <el-radio :label="2">评价年度内发生较大突发环境事件（-6分）</el-radio></div>
          <div> <el-radio :label="3">评价年度内发生重大突发环境事件（-7分）</el-radio></div>
          <div> <el-radio :label="4">评价年度内发生特大突发环境事件（-8分）</el-radio></div>
          <div> <el-radio :label="5">评价年度内无突发环境事件（0分）</el-radio></div>
        </el-radio-group>

        <p class="fileText"></p>
        <label>附件: </label>
        <span style="color: blue; cursor: pointer" @click="checkFile(reviewSubmitDatas.reviewItem19.fileObj.filePath)"
          v-if="reviewSubmitDatas.reviewItem19.fileObj.filePath">{{
            getFileName(reviewSubmitDatas.reviewItem19.fileObj.filePath)
          }}</span>
        <input v-else type="file" accept=".pdf,image/*" objName="reviewItem19" filePathKey="fileObj" senum="19" value=""
          @change="handleUpload" />
        <button v-if="reviewSubmitDatas.reviewItem19.fileObj.filePath"
          @click="reviewSubmitDatas.reviewItem19.fileObj.filePath = ''">
          重新上传
        </button>

        <p></p>
        <div class="button-container">
          <p>
            得分值：<span>{{ reviewSubmitDatas.reviewItem19.score }}</span>
          </p>
          <el-button type='primary' :disabled="!editable"
            @click="saveData({ path: 'Div19Save', itemPath: 'reviewItem19' })">保存</el-button>
        </div>
      </el-collapse-item>

      <el-collapse-item title="20、信访投诉【企业自评与填报】" name="23">
        <template #title>
          <span style="color: #dc6731; font-weight: bold">20、信访投诉【企业自评与填报】</span>
        </template>
        <span style="padding-right: 6px">企业说明</span>
        <el-input style="width: 800px" type="textarea" autosize placeholder="请输入内容"
          v-model="reviewSubmitDatas.reviewItem20.remark"></el-input>
        <el-image style="
            height: 150px;
            width: 267px;
            float: right;
            margin: 20px 80px 20px 0px;
          " :src="require('../../assets/images/guizhouReviewHints/guizhouHints_20.jpg')
            " :preview-src-list="[
    require('../../assets/images/guizhouReviewHints/guizhouHints_20.jpg'),
  ]">
        </el-image>

        <p></p>
        <el-radio-group class="radioDiv" v-model="reviewSubmitDatas.reviewItem20.radioSelect">
          <div> <el-radio :label="1">评价年度内经查实，确因环境污染造成 1
              起群众投诉的（来访投诉、来信投诉、电话投诉
              、网络投诉）（-1分）</el-radio></div>
          <div> <el-radio :label="2">评价年度内经查实，确因环境污染造成 2
              起群众投诉的（来访投诉、来信投诉、电话投诉
              、网络投诉）（-3分）</el-radio></div>
          <div> <el-radio :label="3">评价年度内经查实，确因环境污染造成 3
              起及以上群众投诉的（来访投诉、来信投诉、电话投诉
              、网络投诉）（-5分）</el-radio></div>
          <div> <el-radio :label="4">评价年度内未受到群众环境信访、投诉或经查实环境信访投诉反映情况不属实的（0分）</el-radio></div>
        </el-radio-group>

        <p class="fileText"></p>
        <label>附件: </label>
        <span style="color: blue; cursor: pointer" @click="checkFile(reviewSubmitDatas.reviewItem20.fileObj.filePath)"
          v-if="reviewSubmitDatas.reviewItem20.fileObj.filePath">{{
            getFileName(reviewSubmitDatas.reviewItem20.fileObj.filePath)
          }}</span>
        <input v-else type="file" accept=".pdf,image/*" objName="reviewItem20" filePathKey="fileObj" senum="20" value=""
          @change="handleUpload" />
        <button v-if="reviewSubmitDatas.reviewItem20.fileObj.filePath"
          @click="reviewSubmitDatas.reviewItem20.fileObj.filePath = ''">
          重新上传
        </button>

        <p></p>
        <div class="button-container">
          <p>
            得分值：<span>{{ reviewSubmitDatas.reviewItem20.score }}</span>
          </p>
          <el-button type='primary' :disabled="!editable"
            @click="saveData({ path: 'Div20Save', itemPath: 'reviewItem20' })">保存</el-button>
        </div>
      </el-collapse-item>

      <el-collapse-item title="21、清洁生产审核【加分项】" name="24">
        <template #title>
          <span style="color: #dc6731; font-weight: bold">21、清洁生产审核【加分项】</span>
        </template>
        <span style="padding-right: 6px">企业说明</span>
        <el-input style="width: 800px" type="textarea" autosize placeholder="请输入内容"
          v-model="reviewSubmitDatas.reviewItem21.remark"></el-input>
        <el-image style="
            height: 150px;
            width: 267px;
            float: right;
            margin: 20px 80px 20px 0px;
          " :src="require('../../assets/images/guizhouReviewHints/guizhouHints_21.jpg')
            " :preview-src-list="[
    require('../../assets/images/guizhouReviewHints/guizhouHints_21.jpg'),
  ]">
        </el-image>

        <p></p>
        <el-radio-group class="radioDiv" v-model="reviewSubmitDatas.reviewItem21.radioSelect">
          <div><el-radio :label="1">评价年度内未纳入强制性清洁生产审核范围但主动开展清洁生产审核并完成评估验收(2分)</el-radio></div>
          <div> <el-radio :label="2">评价年度内未纳入强制性清洁生产审核范围且未开展清洁生产审核并完成评估验收(0分)</el-radio></div>
        </el-radio-group>
        <p class="fileText"></p>
        <label>附件: </label>
        <span style="color: blue; cursor: pointer" @click="checkFile(reviewSubmitDatas.reviewItem21.fileObj.filePath)"
          v-if="reviewSubmitDatas.reviewItem21.fileObj.filePath">{{
            getFileName(reviewSubmitDatas.reviewItem21.fileObj.filePath)
          }}</span>
        <input v-else type="file" accept=".pdf,image/*" objName="reviewItem21" filePathKey="fileObj" senum="21" value=""
          @change="handleUpload" />
        <button v-if="reviewSubmitDatas.reviewItem21.fileObj.filePath"
          @click="reviewSubmitDatas.reviewItem21.fileObj.filePath = ''">
          重新上传
        </button>

        <p></p>
        <div class="button-container">
          <p>
            得分值：<span>{{ reviewSubmitDatas.reviewItem21.score }}</span>
          </p>
          <el-button type='primary' :disabled="!editable"
            @click="saveData({ path: 'Div21Save', itemPath: 'reviewItem21' })">保存</el-button>
        </div>
      </el-collapse-item>

      <el-collapse-item title="22、环境管理体系认证【加分项】" name="25">
        <template #title>
          <span style="color: #dc6731; font-weight: bold">22、环境管理体系认证【加分项】</span>
        </template>
        <span style="padding-right: 6px">企业说明</span>
        <el-input style="width: 800px" type="textarea" autosize placeholder="请输入内容"
          v-model="reviewSubmitDatas.reviewItem22.remark"></el-input>
        <el-image style="
            height: 150px;
            width: 267px;
            float: right;
            margin: 20px 80px 20px 0px;
          " :src="require('../../assets/images/guizhouReviewHints/guizhouHints_22.jpg')
            " :preview-src-list="[
    require('../../assets/images/guizhouReviewHints/guizhouHints_22.jpg'),
  ]">
        </el-image>

        <p></p>
        <el-radio-group class="radioDiv" v-model="reviewSubmitDatas.reviewItem22.radioSelect">
          <div> <el-radio :label="1">评价年度内获得 ISO14001 环境管理体系认证并在有效期内(2分)</el-radio></div>
          <div> <el-radio :label="2">评价年度内未获得 ISO14001 环境管理体系认证(0分)</el-radio></div>
        </el-radio-group>
        <p class="fileText"></p>
        <label>附件: </label>
        <span style="color: blue; cursor: pointer" @click="checkFile(reviewSubmitDatas.reviewItem22.fileObj.filePath)"
          v-if="reviewSubmitDatas.reviewItem22.fileObj.filePath">{{
            getFileName(reviewSubmitDatas.reviewItem22.fileObj.filePath)
          }}</span>
        <input v-else type="file" accept=".pdf,image/*" objName="reviewItem22" filePathKey="fileObj" senum="22" value=""
          @change="handleUpload" />
        <button v-if="reviewSubmitDatas.reviewItem22.fileObj.filePath"
          @click="reviewSubmitDatas.reviewItem22.fileObj.filePath = ''">
          重新上传
        </button>

        <p></p>
        <div class="button-container">
          <p>
            得分值：<span>{{ reviewSubmitDatas.reviewItem22.score }}</span>
          </p>
          <el-button type='primary' :disabled="!editable"
            @click="saveData({ path: 'Div22Save', itemPath: 'reviewItem22' })">保存</el-button>
        </div>
      </el-collapse-item>
      <el-collapse-item title="23、环境污染责任保险【加分项】" name="26">
        <template #title>
          <span style="color: #dc6731; font-weight: bold">23、环境污染责任保险【加分项】</span>
        </template>
        <span style="padding-right: 6px">企业说明</span>
        <el-input style="width: 800px" type="textarea" autosize placeholder="请输入内容"
          v-model="reviewSubmitDatas.reviewItem23.remark"></el-input>
        <el-image style="
            height: 150px;
            width: 267px;
            float: right;
            margin: 20px 80px 20px 0px;
          " :src="require('../../assets/images/guizhouReviewHints/guizhouHints_23.jpg')
            " :preview-src-list="[
    require('../../assets/images/guizhouReviewHints/guizhouHints_23.jpg'),
  ]">
        </el-image>

        <p></p>
        <el-radio-group class="radioDiv" v-model="reviewSubmitDatas.reviewItem23.radioSelect">
          <div> <el-radio :label="1">评价年度内参保环境污染责任保险(2分)</el-radio></div>
          <div> <el-radio :label="2">评价年度内未参保环境污染责任保险(0分)</el-radio></div>
        </el-radio-group>
        <p class="fileText"></p>
        <label>附件: </label>
        <span style="color: blue; cursor: pointer" @click="checkFile(reviewSubmitDatas.reviewItem23.fileObj.filePath)"
          v-if="reviewSubmitDatas.reviewItem23.fileObj.filePath">{{
            getFileName(reviewSubmitDatas.reviewItem23.fileObj.filePath)
          }}</span>
        <input v-else type="file" accept=".pdf,image/*" objName="reviewItem23" filePathKey="fileObj" senum="23" value=""
          @change="handleUpload" />
        <button v-if="reviewSubmitDatas.reviewItem23.fileObj.filePath"
          @click="reviewSubmitDatas.reviewItem23.fileObj.filePath = ''">
          重新上传
        </button>

        <p></p>
        <div class="button-container">
          <p>
            得分值：<span>{{ reviewSubmitDatas.reviewItem23.score }}</span>
          </p>
          <el-button type='primary' :disabled="!editable"
            @click="saveData({ path: 'Div23Save', itemPath: 'reviewItem23' })">保存</el-button>
        </div>
      </el-collapse-item>
      <el-collapse-item title="24、环境责任报告【加分项】" name="27">
        <template #title>
          <span style="color: #dc6731; font-weight: bold">24、环境责任报告【加分项】</span>
        </template>
        <span style="padding-right: 6px">企业说明</span>
        <el-input style="width: 800px" type="textarea" autosize placeholder="请输入内容"
          v-model="reviewSubmitDatas.reviewItem24.remark"></el-input>
        <el-image style="
            height: 150px;
            width: 267px;
            float: right;
            margin: 20px 80px 20px 0px;
          " :src="require('../../assets/images/guizhouReviewHints/guizhouHints_24.jpg')
            " :preview-src-list="[
    require('../../assets/images/guizhouReviewHints/guizhouHints_24.jpg'),
  ]">
        </el-image>
        <p></p>
        <el-radio-group class="radioDiv" v-model="reviewSubmitDatas.reviewItem24.radioSelect">
          <div> <el-radio :label="1">评价年度内主动发布社会环境责任报告(1分)</el-radio></div>
          <div> <el-radio :label="2">评价年度内未发布社会环境责任报告(0分)</el-radio></div>
        </el-radio-group>
        <p class="fileText"></p>
        <label>附件: </label>
        <span style="color: blue; cursor: pointer" @click="checkFile(reviewSubmitDatas.reviewItem24.fileObj.filePath)"
          v-if="reviewSubmitDatas.reviewItem24.fileObj.filePath">{{
            getFileName(reviewSubmitDatas.reviewItem24.fileObj.filePath)
          }}</span>
        <input v-else type="file" accept=".pdf,image/*" objName="reviewItem24" filePathKey="fileObj" senum="24" value=""
          @change="handleUpload" />
        <button v-if="reviewSubmitDatas.reviewItem24.fileObj.filePath"
          @click="reviewSubmitDatas.reviewItem24.fileObj.filePath = ''">
          重新上传
        </button>

        <p></p>
        <div class="button-container">
          <p>
            得分值：<span>{{ reviewSubmitDatas.reviewItem24.score }}</span>
          </p>
          <el-button type='primary' :disabled="!editable"
            @click="saveData({ path: 'Div24Save', itemPath: 'reviewItem24' })">保存</el-button>
        </div>
      </el-collapse-item>

      <el-collapse-item title="25、表彰【加分项】" name="28">
        <template #title>
          <span style="color: #dc6731; font-weight: bold">25、表彰【加分项】</span>
        </template>
        <span style="padding-right: 6px">企业说明</span>
        <el-input style="width: 800px" type="textarea" autosize placeholder="请输入内容"
          v-model="reviewSubmitDatas.reviewItem25.remark"></el-input>
        <el-image style="
            height: 150px;
            width: 267px;
            float: right;
            margin: 20px 80px 20px 0px;
          " :src="require('../../assets/images/guizhouReviewHints/guizhouHints_25.jpg')
            " :preview-src-list="[
    require('../../assets/images/guizhouReviewHints/guizhouHints_25.jpg'),
  ]">
        </el-image>
        <p></p>
        <el-checkbox-group v-model="reviewSubmitDatas.reviewItem25.selectedOptions"
          @change="excludeSwitch('reviewItem25')">
          <el-checkbox label="1" :disabled="reviewSubmitDatas.reviewItem25.selectedOptions.includes('0')
            ">
            评价年度内受到生态环境部表彰(2分)</el-checkbox>
          <br />
          <el-checkbox label="2" :disabled="reviewSubmitDatas.reviewItem25.selectedOptions.includes('0')
            ">
            评价年度内受到省生态环境厅表彰(1分)</el-checkbox>
          <br />
          <el-checkbox label="0">评价年度内未受到表彰(0分)</el-checkbox>
        </el-checkbox-group>

        <label>附件: </label>
        <span style="color: blue; cursor: pointer" @click="checkFile(reviewSubmitDatas.reviewItem25.fileObj.filePath)"
          v-if="reviewSubmitDatas.reviewItem25.fileObj.filePath">{{
            getFileName(reviewSubmitDatas.reviewItem25.fileObj.filePath)
          }}</span>
        <input v-else type="file" accept=".pdf,image/*" objName="reviewItem25" filePathKey="fileObj" senum="25" value=""
          @change="handleUpload" />
        <button v-if="reviewSubmitDatas.reviewItem25.fileObj.filePath"
          @click="reviewSubmitDatas.reviewItem25.fileObj.filePath = ''">
          重新上传
        </button>

        <p></p>
        <div class="button-container">
          <p>
            得分值：<span>{{ reviewSubmitDatas.reviewItem25.score }}</span>
          </p>
          <el-button type='primary' :disabled="!editable"
            @click="saveData({ path: 'Div25Save', itemPath: 'reviewItem25' })">保存</el-button>
        </div>
      </el-collapse-item>
    </el-collapse>
    <div style="
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
      ">
      <el-popconfirm confirm-button-text="确定" cancel-button-text="取消" icon="warning" icon-color="red" title="确定提交全部内容？"
        @confirm="submitReviewResult">
        <template #reference>
          <el-button type="danger">提交全部内容</el-button>
        </template>
      </el-popconfirm>
    </div>
    <p style="margin-top: 40px"></p>
  </div>
</template>

<script>
import api from "../../http/apis";
import { createNamespacedHelpers } from "vuex";
import { ElMessageBox, ElMessage } from "element-plus";
import axios from "axios";
import CONSTS from "../../store/consts"
const { mapState: userState, mapMutations: userMutations } =
  createNamespacedHelpers("user");
export default {
  data() {
    return {
      editable: false,
      hasFile: false,
      activeNames: ["0"],
      companyID: "",
      reviewProjectID: "",
      reviewLoading: false,
      optionsDatas: {
        companyStatusOptions: [
          {
            value: "1",
            label: "正常生产",
          },
          {
            value: "2",
            label: "连续半年以上停产",
          },
          {
            value: "3",
            label: "连续半年以上未投产",
          },
          {
            value: "4",
            label: "搬迁",
          },
          {
            value: "5",
            label: "关闭",
          },
          {
            value: "6",
            label: "一票否决",
          },
          {
            value: "7",
            label: "异常企业",
          },
        ],
        onePollOutOptions: [
          {
            value: 1,
            label: "(一) 因环境违法相关责任人被追究刑事责任的",
          },
          {
            value: 2,
            label:
              "(二) 私设暗管或者利用渗井、渗坑、裂隙、溶洞等违法排放、倾倒、处置水污染物，或者通过私设旁路违法排放大气污染物的",
          },
          {
            value: 3,
            label: "(三) 发生较大以上突发环境事件、环境保护群体性事件的",
          },
          {
            value: 4,
            label:
              "(四) 环评、监测、机动车环保检验等服务机构在环境影响评价、社会检测、机动车环保检验工作中弄虚作假，篡改伪造监测数据，帮助业主单位骗取环评审批文件的",
          },
          {
            value: 5,
            label: "(五) 其他造成生态环境严重损害或者造成严重恶劣社会影响的",
          },
        ],
      },
      currentScore: 0,

      reviewSubmitDatas: {
        promiseLetter: "",
        basicInfo: {
          remark: "",
          huanPingWenJianList: [
            {
              fileName: "",
              filePath: "",
            },
          ],
          piFuWenJianList: [
            {
              fileName: "",
              filePath: "",
            },
          ],
          yanShouWenJianList: [
            {
              fileName: "",
              filePath: "",
            },
          ],

          tongShiYanShou: {
            fileName: "",
            filePath: "",
          },
          paiWuXuKe: {
            fileName: "",
            filePath: "",
          },
          fengXianPingGu: {
            fileName: "",
            filePath: "",
          },
          yingJiYuAn: {
            fileName: "",
            filePath: "",
          },
        },
        danWeiZhengMing: {
          remark: "",
          xinYongDaiMa: "",
          yinYeZhiZhao: {
            fileName: "",
            filePath: "",
          },
          companyStatus: 1
        },
        danWeiZhuangTai: {
          year: "",
          companyStatus: "正常生产",
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
        yiPiaoFouJue: {
          isNotOnePollOut: false,
          onePollOutList: [],
          score: 0,
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem1: {
          remark: "",
          radioSelect1: false,
          radioSelect2: 0,
          selectedOptions: [],
          score: 0,
          fileObj1: {
            fileName: "",
            filePath: "",
          },
          fileObj2: {
            fileName: "",
            filePath: "",
          },
          fileObj3: {
            fileName: "",
            filePath: "",
          },
          fileObj4: {
            fileName: "",
            filePath: "",
          },
          fileObj5: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem2: {
          remark: "",
          score: 0,
          radioSelect: 0,
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem3: {
          remark: "",
          score: 0,
          radioSelect1: false,
          radioSelect2: 0,
          radioSelect3: 0,
          radioSelect4: false,
          radioSelect5: false,
          selectedOptions: [],
          disableSwitch: false,
          fileObj1: {
            fileName: "",
            filePath: "",
          },
          fileObj2: {
            fileName: "",
            filePath: "",
          },
          fileObj3: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem4: {
          remark: "",
          score: 0,
          selectedOptions: [],
          radioSelect1: false,
          radioSelect2: 0,
          radioSelect3: 0,
          radioSelect4: false,
          radioSelect5: false,
          disableSwitch: false,
          fileObj1: {
            fileName: "",
            filePath: "",
          },
          fileObj2: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem5: {
          remark: "",
          score: 0,
          radioSelect1: false,
          radioSelect2: 0,
          radioSelect4: 0,
          selectedOptions: [],
          radioSelect3: false,
          fileObj1: {
            fileName: "",
            filePath: "",
          },
          fileObj2: {
            fileName: "",
            filePath: "",
          },
          fileObj3: {
            fileName: "",
            filePath: "",
          },
          fileObj4: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem6: {
          remark: "",
          score: 0,
          radioSelect: 0,
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem7: {
          remark: "",
          score: 0,
          radioSelect1: 0,
          radioSelect2: false,
          radioSelect3: false,
          fileObj1: {
            fileName: "",
            filePath: "",
          },
          fileObj2: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem8: {
          remark: "",
          score: 0,
          radioSelect: 0,
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem9: {
          remark: "",
          score: 0,
          radioSelect: 0,
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem10: {
          remark: "",
          score: 0,
          radioSelect: 0,
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem11: {
          remark: "",
          score: 0,
          radioSelect1: 0,
          radioSelect2: 0,
          radioSelect3: true,
          radioSelect4: true,
          fileObj1: {
            fileName: "",
            filePath: "",
          },

          fileObj2: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem12: {
          remark: "",
          score: 0,
          radioSelect: 0,
          selectedOptions: [],
          casesNum: 0,
          fileObj1: {
            fileName: "",
            filePath: "",
          },
          fileObj2: {
            fileName: "",
            filePath: "",
          },
          fileObj3: {
            fileName: "",
            filePath: "",
          },
          // fileObj4: {
          //   fileName: "",
          //   filePath: "",
          // },
          // fileObj5: {
          //   fileName: "",
          //   filePath: "",
          // },
        },
        reviewItem13: {
          remark: "",
          score: 0,
          radioSelect: 0,
          selectedOptions: [],

          fileObj1: {
            fileName: "",
            filePath: "",
          },
          fileObj2: {
            fileName: "",
            filePath: "",
          },
          fileObj3: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem14: {
          remark: "",
          score: 0,
          radioSelect: "",
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem15: {
          remark: "",
          score: 0,
          radioSelect: "",
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem16: {
          remark: "",
          counter1: 0,
          counter2: 0,
          counter3: 0,
          radioSelect: 0,
          score: 0,
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem17: {
          remark: "",
          score: 0,
          radioSelect: 0,
          counter: 0,
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem18: {
          remark: "",
          score: 0,
          radioSelect: 0,
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem19: {
          remark: "",
          score: 0,
          radioSelect: 0,
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem20: {
          remark: "",
          score: 0,
          radioSelect: 0,
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem21: {
          remark: "",
          score: 0,
          radioSelect: 0,
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem22: {
          remark: "",
          score: 0,
          radioSelect: 0,
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem23: {
          remark: "",
          score: 0,
          radioSelect: 0,
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem24: {
          remark: "",
          score: 0,
          radioSelect: 0,
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem25: {
          remark: "",
          score: 0,
          selectedOptions: [],
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem26: {
          remark: "",
          score: 0,
          radioSelect: "",
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem27: {
          remark: "",
          score: 0,
          radioSelect: "",
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
      },
    };
  },
  computed: {
    // ...userState(["isOrg"]),
    radioChanger1() {
      return this.reviewSubmitDatas.reviewItem5.radioSelect4;
    },
  },
  created() {
    this.getReviewInfo();
    this.getNowYear();
  },

  watch: {
    radioChanger1(newValue) {
      if (newValue == 1) {
        this.reviewSubmitDatas.reviewItem5.radioSelect2 = 0;
      } else {
        this.reviewSubmitDatas.reviewItem5.selectedOptions = [];
      }
    },
  },
  methods: {
    // ...userMutations(["setIsOrg"]),
    getFileName(val) {
      if (val != null) {
        if (val || val != "") {
          const fileUrl = val.split("/");
          const fileName = fileUrl.pop();
          return fileName;
        } else {
          const str = "无";
          return str;
        }
      }
    },
    getNowYear() {
      let dateObj = new Date();
      const ye = dateObj.getFullYear() - 1;
      this.reviewSubmitDatas.danWeiZhuangTai.year = ye;
    },
    addFileList(e) {
      const path = e.srcElement.attributes.fileLabel.value;
      this.reviewSubmitDatas.basicInfo[path].push({
        fileName: "",
        filePath: "",
      });
      console.info("added file", this.reviewSubmitDatas.basicInfo[path]);
    },
    delFileList(e) {
      const path = e.srcElement.attributes.fileLabel.value;
      const idx = e.srcElement.attributes.idx.value;
      this.reviewSubmitDatas.basicInfo[path].splice(idx, 1);
    },
    checkOrgCode() {
      const orgCode = this.reviewSubmitDatas.danWeiZhengMing.xinYongDaiMa;
      window.open(
        "https://www.creditchina.gov.cn/xinyongfuwu/tongyishehuixinyongdaimachaxunzhuanlan/shehuixinyongdaimachaxun/index.html?index=1&keyword=" +
        orgCode,
        "_blank"
      );
    },
    getPromiseLetterTemplate() {
      window.open(
        "http://221.10.90.153:9093/%E7%8E%AF%E5%A2%83%E4%BF%A1%E7%94%A8%E8%AF%84%E4%BB%B7%E6%89%BF%E8%AF%BA%E4%B9%A6%EF%BC%88%E6%A8%A1%E6%9D%BF%EF%BC%89.docx"
      );
    },

    async setBackUp() {
      // const JsonStr = JSON.stringify(this.reviewSubmitDatas);
      // const { data } = await api.reviewTaskApi.saveSubmitData({
      //   Id: this.reviewProjectID,
      //   JsonStr,
      // });
    },

    async getBackUp() {
      const { data } = await api.reviewTaskApi.getSubmitByTaskID(
        this.companyID
      );

      if (data.isSuccessful) {
        const t = data.resultObj;
        console.info(data.resultObj);
        let b = this.reviewSubmitDatas;
        console.info(t);
        b.promiseLetter = t.cndivF1;
        b.danWeiZhengMing.yinYeZhiZhao.filePath = t.divv1F1;
        b.danWeiZhengMing.xinYongDaiMa = t.divv1t1;
        b.danWeiZhengMing.remark = t.divv1t2;
        b.danWeiZhengMing.companyStatus = t.companyStatus || 1;
        b.reviewItem1.fileObj1.filePath = t.div1F1;
        b.reviewItem1.fileObj2.filePath = t.div1F2;
        b.reviewItem1.fileObj3.filePath = t.div1F3;
        b.reviewItem1.fileObj4.filePath = t.div1F4;
        b.reviewItem1.fileObj5.filePath = t.div1F5;
        if (t.div1r1 == 0) {
          b.reviewItem1.radioSelect1 = false;
        } else {
          b.reviewItem1.radioSelect1 = true;
        }
        b.reviewItem1.selectedOptions = this.deToxicateArr(t.div1r2);
        b.reviewItem1.radioSelect2 = parseInt(t.div1r3);
        b.reviewItem1.remark = t.div1t1;

        b.reviewItem2.fileObj.filePath = t.div2F1;
        b.reviewItem2.radioSelect = parseInt(t.div2r1);
        b.reviewItem2.remark = t.div2t1;

        b.reviewItem3.fileObj1.filePath = t.div3F1;
        b.reviewItem3.fileObj2.filePath = t.div3F2;
        b.reviewItem3.fileObj3.filePath = t.div3F3;

        b.reviewItem3.radioSelect1 = this.radioNumToBoo(t.div3r1);
        b.reviewItem3.radioSelect2 = parseInt(t.div3r2);
        b.reviewItem3.radioSelect2
          ? (b.reviewItem3.radioSelect4 = true)
          : (b.reviewItem3.radioSelect4 = false);
        b.reviewItem3.radioSelect3 = parseInt(t.div3r3);
        b.reviewItem3.radioSelect3
          ? (b.reviewItem3.radioSelect5 = true)
          : (b.reviewItem3.radioSelect5 = false);
        b.reviewItem3.remark = t.div3t1;

        b.reviewItem4.fileObj1.filePath = t.div4F1;
        b.reviewItem4.fileObj2.filePath = t.div4F2;
        b.reviewItem4.radioSelect1 = this.radioNumToBoo(t.div4r1);
        b.reviewItem4.radioSelect2 = parseInt(t.div4r2);
        b.reviewItem4.radioSelect2
          ? (b.reviewItem4.radioSelect4 = true)
          : (b.reviewItem4.radioSelect4 = false);
        b.reviewItem4.radioSelect3 = parseInt(t.div4r3);
        b.reviewItem4.radioSelect3
          ? (b.reviewItem4.radioSelect5 = true)
          : (b.reviewItem4.radioSelect5 = false);
        b.reviewItem4.remark = t.div4t1;

        b.reviewItem5.fileObj1.filePath = t.div5F1;
        b.reviewItem5.fileObj2.filePath = t.div5F2;
        b.reviewItem5.fileObj3.filePath = t.div5F3;
        b.reviewItem5.fileObj4.filePath = t.div5F4;
        b.reviewItem5.radioSelect1 = this.radioNumToBoo(t.div5r1);
        b.reviewItem5.radioSelect2 = parseInt(t.div5r2);

        //先注释掉，div5r1默认返回会冲突
        if (t.div5r1 == 1) {
          b.reviewItem5.radioSelect3 = false;
        }
        if (t.div5r4 == 1) {
          b.reviewItem5.radioSelect1 = false;
        }

        b.reviewItem5.selectedOptions = this.deToxicateArr(t.div5r3);

        if (t.div5r5) {
          b.reviewItem5.radioSelect4 = parseInt(t.div5r5);
        }
        b.reviewItem5.remark = t.div5t1;

        b.reviewItem6.fileObj.filePath = t.div6F1;
        b.reviewItem6.radioSelect = parseInt(t.div6r1);
        b.reviewItem6.remark = t.div6t1;

        b.reviewItem7.fileObj1.filePath = t.div7F1;
        b.reviewItem7.fileObj2.filePath = t.div7F2;
        b.reviewItem7.radioSelect1 = parseInt(t.div7r1);
        b.reviewItem7.radioSelect2 = this.radioNumToBoo(t.div7r2);
        b.reviewItem7.radioSelect3 = this.radioNumToBoo(t.div7r3);
        b.reviewItem7.remark = t.div7t1;

        b.reviewItem8.fileObj.filePath = t.div8F1;
        b.reviewItem8.radioSelect = parseInt(t.div8r1);
        b.reviewItem8.remark = t.div8t1;

        b.reviewItem9.fileObj.filePath = t.div9F1;
        b.reviewItem9.radioSelect = parseInt(t.div9r1);
        b.reviewItem9.remark = t.div9t1;

        b.reviewItem10.fileObj.filePath = t.div10F1;
        b.reviewItem10.radioSelect = parseInt(t.div10r1);
        b.reviewItem10.remark = t.div10t1;

        b.reviewItem11.radioSelect1 = parseInt(t.div11r1);
        !b.reviewItem11.radioSelect1
          ? (b.reviewItem11.radioSelect3 = false)
          : null;
        b.reviewItem11.radioSelect2 = parseInt(t.div11r2);
        !b.reviewItem11.radioSelect2
          ? (b.reviewItem11.radioSelect4 = false)
          : null;
        b.reviewItem11.fileObj1.filePath = t.div11F1;
        b.reviewItem11.fileObj2.filePath = t.div11F2;
        b.reviewItem11.remark = t.div11t1;

        b.reviewItem12.radioSelect = parseInt(t.div12r1);
        b.reviewItem12.selectedOptions = this.deToxicateArr(t.div12r2);
        b.reviewItem12.selectedOptions = b.reviewItem12.selectedOptions.filter(
          (item) => {
            if (item != 0) {
              return true;
            }
          }
        );

        b.reviewItem12.fileObj1.filePath = t.div12F1;
        b.reviewItem12.fileObj2.filePath = t.div12F2;
        b.reviewItem12.fileObj3.filePath = t.div12F3;
        // b.reviewItem12.fileObj4.filePath = t.div12F4;
        // b.reviewItem12.fileObj5.filePath = t.div12F5;
        b.reviewItem12.remark = t.div12t1;

        b.reviewItem13.radioSelect = this.radioNumToBoo(t.div13r1);
        b.reviewItem13.selectedOptions = this.deToxicateArr(t.div13r2);
        b.reviewItem13.fileObj1.filePath = t.div13F1;
        b.reviewItem13.fileObj2.filePath = t.div13F2;
        b.reviewItem13.fileObj3.filePath = t.div13F3;
        b.reviewItem13.remark = t.div13t1;

        b.reviewItem14.radioSelect = parseInt(t.div14r1);
        b.reviewItem14.fileObj.filePath = t.div14F1;
        b.reviewItem14.remark = t.div14t1;

        b.reviewItem15.radioSelect = parseInt(t.div15r1);
        b.reviewItem15.fileObj.filePath = t.div15F1;
        b.reviewItem15.remark = t.div15t1;

        b.reviewItem16.radioSelect = parseInt(t.div16r1);
        b.reviewItem16.counter1 = t.div16n1;
        b.reviewItem16.counter2 = t.div16n2;
        b.reviewItem16.counter3 = t.div16n3;
        b.reviewItem16.fileObj.filePath = t.div16F1;
        b.reviewItem16.remark = t.div16t1;

        b.reviewItem17.radioSelect = parseInt(t.div17r1);
        b.reviewItem17.counter = t.div17n1;
        b.reviewItem17.fileObj.filePath = t.div17F1;
        b.reviewItem17.remark = t.div17t1;

        b.reviewItem18.radioSelect = parseInt(t.div18r1);
        b.reviewItem18.fileObj.filePath = t.div18F1;
        b.reviewItem18.remark = t.div18t1;

        b.reviewItem19.radioSelect = parseInt(t.div19r1);
        b.reviewItem19.fileObj.filePath = t.div19F1;
        b.reviewItem19.remark = t.div19t1;

        b.reviewItem20.radioSelect = parseInt(t.div20r1);
        b.reviewItem20.fileObj.filePath = t.div20F1;
        b.reviewItem20.remark = t.div20t1;

        b.reviewItem21.radioSelect = parseInt(t.div21r1);
        b.reviewItem21.fileObj.filePath = t.div21F1;
        b.reviewItem21.remark = t.div21t1;

        b.reviewItem22.radioSelect = parseInt(t.div22r1);
        b.reviewItem22.fileObj.filePath = t.div22F1;
        b.reviewItem22.remark = t.div22t1;

        b.reviewItem23.radioSelect = parseInt(t.div23r1);
        b.reviewItem23.fileObj.filePath = t.div23F1;
        b.reviewItem23.remark = t.div23t1;

        b.reviewItem24.radioSelect = parseInt(t.div24r1);
        b.reviewItem24.fileObj.filePath = t.div24F1;
        b.reviewItem24.remark = t.div24t1;

        b.reviewItem25.selectedOptions = this.deToxicateArr(t.div25r1);
        b.reviewItem25.fileObj.filePath = t.div25F1;
        b.reviewItem25.remark = t.div25t1;
        //  分数赋值
        b.reviewItem1.score = t.score1;
        b.reviewItem2.score = t.score2;
        b.reviewItem3.score = t.score3;
        b.reviewItem4.score = t.score4;
        b.reviewItem5.score = t.score5;
        b.reviewItem6.score = t.score6;
        b.reviewItem7.score = t.score7;
        b.reviewItem8.score = t.score8;
        b.reviewItem9.score = t.score9;
        b.reviewItem10.score = t.score10;
        b.reviewItem11.score = t.score11;
        b.reviewItem12.score = t.score12;
        b.reviewItem13.score = t.score13;
        b.reviewItem14.score = t.score14;
        b.reviewItem15.score = t.score15;
        b.reviewItem16.score = t.score16;
        b.reviewItem17.score = t.score17;
        b.reviewItem18.score = t.score18;
        b.reviewItem19.score = t.score19;
        b.reviewItem20.score = t.score20;
        b.reviewItem21.score = t.score21;
        b.reviewItem22.score = t.score22;
        b.reviewItem23.score = t.score23;
        b.reviewItem24.score = t.score24;
        b.reviewItem25.score = t.score25;
      }
    },

    radioChange1(e) {
      // if (e == 1) {
      //   this.reviewSubmitDatas.reviewItem5.radioSelect2 = 0;
      // } else {
      //   this.reviewSubmitDatas.reviewItem5.selectedOptions = [];
      // }
    },

    async delBackUp() { },
    checkFile(filePath) {
      this.BASE_URL = CONSTS.BASE_URL.slice(0, -1);

      window.open(this.BASE_URL + filePath);
    },
    async updateScore() {
      const res = await api.reviewTaskApi.getSubmitByTaskID(this.companyID);

      this.currentScore = parseFloat(res.data.resultData);
    },
    async handleUpload(e) {
      let formData = new FormData();
      formData.append("file", e.target.files[0]);
      const seqnum = e.srcElement.attributes.senum.value;
      const objName = e.srcElement.attributes.objName.value;
      const filePathKey = e.srcElement.attributes.filePathKey.value;

      const type = e.target.files[0].type
      if (type.includes('application') && type != 'application/pdf') {
        console.info("wrong file type")
        ElMessage({
          message: '只能上传PDF、jpg、png格式的文件',
          type: "error",
        });
        return
      }
      const fileObj = e.target.files[0]
      const fileName = fileObj.name.substring(0, fileObj.name.lastIndexOf("."))
      console.info("file type", e.target.files[0].type)
      console.info("file name", fileName)
      if (objName == "basicInfo") {
        const filePathKey2 = e.srcElement.attributes.filePathKey2.value;
        const file = e.target.files[0];
        const { data } = await api.reviewTaskApi.saveFile({
          uappcomid: this.companyID,
          seqnum,
          fileName,
          formData,
          file,
        });
        if (data.isSuccessful) {
          this.reviewSubmitDatas[objName][filePathKey][filePathKey2].filePath =
            data.resultObj[0];
          this.reviewSubmitDatas[objName][filePathKey][filePathKey2].fileName =
            this.getFileName(data.resultObj[0]);
        } else {
          this.reviewSubmitDatas[objName][filePathKey][filePathKey2].filePath = ''
          this.reviewSubmitDatas[objName][filePathKey][filePathKey2].fileName = ''
          ElMessage({
            message: data.resultMsg || "未知错误，请联系管理员",
            type: "error",
          });
        }
      } else if (objName == "promiseLetter") {
        const file = e.target.files[0];
        const { data } = await api.reviewTaskApi.saveFile({
          uappcomid: this.companyID,
          seqnum,
          formData,
          fileName,
          file,
        });
        if (data.isSuccessful) {
          this.reviewSubmitDatas.promiseLetter = data.resultObj[0];
        } else {
          this.reviewSubmitDatas.promiseLetter = ''
          ElMessage({
            message: data.resultMsg || "未知错误，请联系管理员",
            type: "error",
          });
        }
      } else {
        const file = e.target.files[0];
        const { data } = await api.reviewTaskApi.saveFile({
          uappcomid: this.companyID,
          seqnum,
          formData,
          fileName,
          file,
        });
        if (data.isSuccessful) {
          this.reviewSubmitDatas[objName][filePathKey].filePath =
            data.resultObj[0];

          this.reviewSubmitDatas[objName][filePathKey].fileName =
            this.getFileName(data.resultObj[0]);
        } else {
          this.reviewSubmitDatas[objName][filePathKey].filePath = ''
          this.reviewSubmitDatas[objName][filePathKey].fileName = ''
          ElMessage({
            message: data.resultMsg || "未知错误，请联系管理员",
            type: "error",
          });
        }
      }
    },
    async getReviewInfo() {
      this.reviewLoading = true;
      if (this.$route.query.unitAID) {
        this.companyID = this.$route.query.unitAID;

        const res = await api.reviewTaskApi.getSubmitByTaskID(this.companyID);
        // if (res.data.ResultObj.isAudit) {
        // 	this.setIsOrg(false);
        // } else {
        // 	this.setIsOrg(true);
        // }

        this.isOrg = false;

        // this.editable = res.data.ResultObj.appraiseCompany.IsAppealSubmit == 0 ? true : false,
        this.editable = true;
        this.currentScore = parseFloat(res.data.resultData);
        this.reviewProjectID = res.data.resultObj.id;
        this.getBackUp();
        this.reviewLoading = false;
      } else {
        alert("填报功能需要联系专员开通，如未开通请联系QQ:13548580");
        this.$router.push("chongqingreviewlist");
      }
    },
    handleChange(val) { },
    //    async downloadPromiseLetter(){
    // const {data}= await axios.get(
    //   "http://221.10.90.140:8085/%E8%B4%B5%E5%B7%9E%E7%9C%81%E9%87%8D%E7%82%B9%E6%8E%92%E6%B1%A1%E5%8D%95%E4%BD%8D%E5%8F%82%E5%8A%A0%E7%8E%AF%E5%A2%83%E4%BF%A1%E7%94%A8%E8%AF%84%E4%BB%B7%E5%B7%A5%E4%BD%9C%E6%89%BF%E8%AF%BA%E4%B9%A6.pdf"
    // )
    //         let url = window.URL.createObjectURL(data);
    //         let link = document.createElement("a");
    //         link.style.display = "none";
    //         link.href = url;
    //         const year = new Date().getUTCFullYear();
    //         const month = new Date().getUTCMonth() + 1;
    //         const day = new Date().getUTCDate();
    //         const dateStr = `${year}-${month}-${day}`;
    //         link.setAttribute("download", `导出-${typeStr}-${dateStr}.xlsx`);
    //         document.body.appendChild(link);
    //         link.click();
    //     },
    radioNumToBoo(num) {
      if (num == 1) {
        return true;
      } else {
        return false;
      }
    },
    radioFilter(boo, obj, path) {
      switch (path) {
        case "reviewItem1div1r1":
          if (boo) {
            obj.radioSelect2 = 0;
            obj.selectedOptions = [];
            return 1;
          } else {
            return 0;
          }
        case "reviewItem5div5r1":
          if (boo) {
            obj.radioSelect2 = 0;
            obj.radioSelect3 = 0;
            obj.selectedOptions = [];
            return 1;
          } else {
            return 0;
          }
        case "reviewItem5div5r4":
          if (boo) {
            obj.radioSelect1 = 0;
            obj.radioSelect2 = 0;
            obj.selectedOptions = [];

            return 1;
          } else {
            return 0;
          }
        case "reviewItem7div7r2":
          if (boo) {
            return 1;
          } else {
            return 0;
          }
        case "reviewItem7div7r3":
          if (boo) {
            obj.radioSelect1 = 0;
            obj.radioSelect2 = 0;
            console.info("obj", obj);
            return 1;
          } else {
            return 0;
          }
        case "reviewItem13div13r1":
          if (boo) {
            obj.selectedOptions = [];
            return 1;
          } else {
            return 0;
          }
        case "singleItem":
          if (boo) {
            return 1;
          } else {
            return 0;
          }
      }
      if (boo) {
        obj.radioSelect2 = 0;
        obj.radioSelect3 = 0;

        return 1;
      } else {
        return 0;
      }
    },
    onePollOutPrint(val, reviewItemPath, num, expel = false) {
      console.info(val);
      console.info("reviewItemPath", reviewItemPath);
      if (val.includes(num) && expel == true) {
        if (reviewItemPath == "reviewItem10") {
          this.reviewSubmitDatas[reviewItemPath].radioSelect1 = "";
          this.reviewSubmitDatas[reviewItemPath].radioSelect2 = "";
        } else if (reviewItemPath == "reviewItem4") {
          this.reviewSubmitDatas[reviewItemPath].radioSelect = "";
          this.reviewSubmitDatas[reviewItemPath].selectedOptions = ["1"];
        } else if (reviewItemPath == "reviewItem3") {
          this.reviewSubmitDatas[reviewItemPath].selectedOptions = ["0"];
        } else if (reviewItemPath == "reviewItem15") {
          this.reviewSubmitDatas[reviewItemPath].selectedOptions = ["0"];
        }
        this.reviewSubmitDatas[reviewItemPath].disableSwitch = true;
      } else {
        this.reviewSubmitDatas[reviewItemPath].disableSwitch = false;
      }
    },
    excludeSwitch(reviewItemPath) {
      switch (reviewItemPath) {
        case "reviewItem25":
          if (
            this.reviewSubmitDatas[reviewItemPath].selectedOptions.includes("0")
          ) {
            console.info(
              (this.reviewSubmitDatas[reviewItemPath].selectedOptions = ["0"])
            );
          }
      }
    },
    async changeCompanyStatus(unitAppcomid) {
      const { data } = await api.reviewTaskApi.changeGSGBLevel(
        {
          unitAppcomid,
          gsgb: 2,
          levelStr: "停产",
          remark: "停产",
        }
      )
    },

    async saveData({ path, itemPath }) {
      const obj = this.reviewSubmitDatas[itemPath];
      // console.info("current data to save {obj}", obj);
      this.hasFile = false;
      const keys = Object.keys(obj);
      if (itemPath == "promiseLetter") {
        if (this.reviewSubmitDatas.promiseLetter != "") {
          this.hasFile = true;
        } else {
          this.hasFile = false;
        }
      } else if (itemPath == "danWeiZhengMing") {

        if (
          this.reviewSubmitDatas.danWeiZhengMing.yinYeZhiZhao.filePath != ""
        ) {
          this.hasFile = true;
        } else {
          this.hasFile = false;
        }
        if (
          this.reviewSubmitDatas.danWeiZhengMing.companyStatus == '2'
        ) {
          this.changeCompanyStatus(this.reviewProjectID)
        }
      } else {
        let hasFileArr = [];
        keys.forEach((item) => {
          if (item.includes("fileObj")) {
            if (!obj[item].filePath == "") {
              // console.info(obj[item], true);
              this.hasFile = true;
              hasFileArr.push(true);
            } else {
              // console.info(obj[item], false);
              this.hasFile = false;
              hasFileArr.push(false);
            }
          }
        });
        // console.info("hasFileArr", hasFileArr);
        this.hasFile = hasFileArr.every((item) => {
          // console.info(item);
          return item == true;
        });
      }
      // console.info("hasFileArr2", this.hasFile);

      let paraObj = {};
      let dataObj = {};
      let withData = false;
      switch (itemPath) {
        case "promiseLetter":
          paraObj = {
            cndivF1: this.reviewSubmitDatas.promiseLetter,
          };
          break;
        case "basicInfo":
          withData = true;
          paraObj = {
            div30t1: obj.remark || "",
          };
          dataObj = {
            huanPingWenJianList: obj.huanPingWenJianList,
            piFuWenJianList: obj.piFuWenJianList,
            yanShouWenJianList: obj.yanShouWenJianList,
          };
          // console.info("paraobj", dataObj);
          break;
        case "danWeiZhengMing":
          paraObj = {
            divv1t1: obj.xinYongDaiMa,
            companyStatus: obj.companyStatus,
            divv1t2: obj.remark || "",
            divv1F1: obj.yinYeZhiZhao.filePath || "",
          };
          break;
        case "danWeiZhuangTai":
          let dateObj = new Date();
          const ye = dateObj.getFullYear();
          if (ye == 2021) {
            obj.year = 2020;
          }
          paraObj = {
            divv2t1: obj.year,
            divv2t2: obj.companyStatus,
            divv2F1: obj.fileObj.filePath || "",
          };
          this.hasFile = true;
          break;
        case "yiPiaoFouJue":
          let num = 0;
          if (!obj.isNotOnePollOut) {
            num = 1;
          } else {
            num = 0;
          }
          const ax = obj.onePollOutList;
          let cx = [];
          ax.forEach((item) => {
            if (typeof item === "number") {
              console.info(item == NaN);
              cx.push(item);
            }
          });

          let arrWithOutNaN = [];
          cx.forEach((item) => {
            if (item === item) {
              arrWithOutNaN.push(item);
            }
          });

          paraObj = {
            divv3r1: num,
            divv3r2: arrWithOutNaN.toString() || "",
            divv3F2: obj.fileObj.filePath || "",
          };
          if (!paraObj.divv3r1) {
            hasFile = true;
          }
          break;
        case "reviewItem1":
          paraObj = {
            div1t1: obj.remark || "",
            div1r1: this.radioFilter(
              obj.radioSelect1,
              obj,
              "reviewItem1div1r1"
            ),
            div1r2: obj.selectedOptions.toString(),
            div1r3: obj.radioSelect2,
            div1F1: obj.fileObj1.filePath || "",
            div1F2: obj.fileObj2.filePath || "",
            div1F3: obj.fileObj3.filePath || "",
            div1F4: obj.fileObj4.filePath || "",
            div1F5: obj.fileObj5.filePath || "",
          };

          if (paraObj.div1r1 && paraObj.div1F1) {
            paraObj.div1r2 = 0;
            this.hasFile = true;
          }
          const reviewItem1Keys = Object.keys(paraObj);
          if (paraObj.div1r2.length == 7 && paraObj.div1r2.includes("1")) {
            let neededFilesArr = [];
            reviewItem1Keys.forEach((item, index) => {
              if (item.includes("div1F")) {
                // console.info(paraObj[item]);
                if (paraObj[item]) {
                  neededFilesArr.push(index);
                }
              }
            });
            console.log(neededFilesArr);
            const filesShouldHaveArr = [5, 6, 7, 8];
            let containsAll = filesShouldHaveArr.every((i) =>
              neededFilesArr.includes(i)
            );
            this.hasFile = containsAll;
          } else if (obj.selectedOptions.length == 3 && paraObj.div1r3 != 3) {
            console.log(obj.selectedOptions);
            let neededFilesArr = [];
            reviewItem1Keys.forEach((item, index) => {
              if (item.includes("div1F")) {
                if (paraObj[item]) {
                  neededFilesArr.push(index);
                }
              }
            });
            console.log(neededFilesArr);
            const filesShouldHaveArr = [5, 6, 8];
            let containsAll = filesShouldHaveArr.every((i) =>
              neededFilesArr.includes(i)
            );
            this.hasFile = containsAll;
            if (!containsAll) {
              let neededFilesArr = [];
              reviewItem1Keys.forEach((item, index) => {
                if (item.includes("div1F")) {
                  if (paraObj[item]) {
                    neededFilesArr.push(index);
                  }
                }
              });
              console.log(neededFilesArr);
              const filesShouldHaveArr = [6, 7, 8];
              let containsAll = filesShouldHaveArr.every((i) =>
                neededFilesArr.includes(i)
              );
              this.hasFile = containsAll;
              if (!containsAll) {
                let neededFilesArr = [];
                reviewItem1Keys.forEach((item, index) => {
                  if (item.includes("div1F")) {
                    if (paraObj[item]) {
                      neededFilesArr.push(index);
                    }
                  }
                });
                console.log(neededFilesArr);
                const filesShouldHaveArr = [5, 7, 8];
                let containsAll = filesShouldHaveArr.every((i) =>
                  neededFilesArr.includes(i)
                );
                this.hasFile = containsAll;
              }
            }
          } else if (obj.selectedOptions.length == 2 && paraObj.div1r3 != 3) {
            let neededFilesArr = [];
            reviewItem1Keys.forEach((item, index) => {
              if (item.includes("div1F")) {
                if (paraObj[item]) {
                  neededFilesArr.push(index);
                }
              }
            });
            console.log(neededFilesArr);
            const filesShouldHaveArr = [5, 8];
            let containsAll = filesShouldHaveArr.every((i) =>
              neededFilesArr.includes(i)
            );
            this.hasFile = containsAll;
            if (!containsAll) {
              let neededFilesArr = [];
              reviewItem1Keys.forEach((item, index) => {
                if (item.includes("div1F")) {
                  if (paraObj[item]) {
                    neededFilesArr.push(index);
                  }
                }
              });
              console.log(neededFilesArr);
              const filesShouldHaveArr = [6, 8];
              let containsAll = filesShouldHaveArr.every((i) =>
                neededFilesArr.includes(i)
              );
              this.hasFile = containsAll;
              if (!containsAll) {
                let neededFilesArr = [];
                reviewItem1Keys.forEach((item, index) => {
                  if (item.includes("div1F")) {
                    if (paraObj[item]) {
                      neededFilesArr.push(index);
                    }
                  }
                });
                console.log(neededFilesArr);
                const filesShouldHaveArr = [7, 8];
                let containsAll = filesShouldHaveArr.every((i) =>
                  neededFilesArr.includes(i)
                );
                this.hasFile = containsAll;
              }
            }
          } else if (paraObj.div1r1 == 1) {
            let neededFilesArr = [];
            reviewItem1Keys.forEach((item, index) => {
              // console.info(index, "itemsss", item);
              if (item.includes("div1F")) {
                if (paraObj[item]) {
                  neededFilesArr.push(index);
                }
              }
            });
            const filesShouldHaveArr = [4];
            let containsAll = filesShouldHaveArr.every((i) =>
              neededFilesArr.includes(i)
            );
            this.hasFile = containsAll;
          } else if (obj.selectedOptions.length == 1 && paraObj.div1r3 != 3) {
            let neededFilesArr = [];
            reviewItem1Keys.forEach((item, index) => {
              if (item.includes("div1F")) {
                if (paraObj[item]) {
                  neededFilesArr.push(index);
                }
              }
            });
            const filesShouldHaveArr = [8];
            let containsAll = filesShouldHaveArr.every((i) =>
              neededFilesArr.includes(i)
            );
            this.hasFile = containsAll;
          } else if (paraObj.div1r3 == 3) {
            this.hasFile = true;
          }
          console.info("div1 obj", paraObj);
          break;
        case "reviewItem2":
          paraObj = {
            div2t1: obj.remark || "",
            div2r1: obj.radioSelect,
            div2F1: obj.fileObj.filePath || "",
            div2F2: "",
          };
          break;
        case "reviewItem3":
          paraObj = {
            div3t1: obj.remark || "",
            div3r1: this.radioFilter(obj.radioSelect1, obj),
            div3r2: obj.radioSelect4 ? obj.radioSelect2 : 0,
            div3r3: obj.radioSelect5 ? obj.radioSelect3 : 0,
            div3F1: obj.fileObj1.filePath || "",
            div3F2: obj.fileObj2.filePath || "",
            div3F3: obj.fileObj3.filePath || "",
          };
          const reviewItem3Keys = Object.keys(paraObj);
          let neededFilesArr2 = [];
          if (paraObj.div3r1 == 0) {
            if (obj.radioSelect4) {
              reviewItem3Keys.forEach((item, index) => {
                if (item.includes("div3F2")) {
                  // console.info(item, index);
                  if (paraObj[item]) {
                    neededFilesArr2.push(index);
                  }
                }
              });
              const filesShouldHaveArr = [5];
              let containsAll = filesShouldHaveArr.every((i) =>
                neededFilesArr2.includes(i)
              );

              this.hasFile = containsAll;
            }
            if (obj.radioSelect5) {
              reviewItem3Keys.forEach((item, index) => {
                if (item.includes("div3F3")) {
                  // console.info(item, index);
                  if (paraObj[item]) {
                    neededFilesArr2.push(index);
                  }
                }
              });
              const filesShouldHaveArr = [6];
              let containsAll = filesShouldHaveArr.every((i) =>
                neededFilesArr2.includes(i)
              );
              this.hasFile = containsAll;
            }

            // console.log(containsAll)
          } else {
            reviewItem3Keys.forEach((item, index) => {
              if (item.includes("div3F")) {
                //  console.info(item, index);
                if (paraObj[item]) {
                  neededFilesArr2.push(index);
                }
              }
            });
            const filesShouldHaveArr = [4];
            let containsAll = filesShouldHaveArr.every((i) =>
              neededFilesArr2.includes(i)
            );
            this.hasFile = containsAll;
          }
          break;
        case "reviewItem4":
          paraObj = {
            div4t1: obj.remark || "",
            div4r1: this.radioFilter(obj.radioSelect1, obj),
            div4r2: obj.radioSelect4 ? obj.radioSelect2 : 0,
            div4r3: obj.radioSelect5 ? obj.radioSelect3 : 0,
            div4F1: obj.fileObj1.filePath || "",
            div4F2: obj.fileObj2.filePath || "",
          };
          const reviewItem4Keys = Object.keys(paraObj);
          let neededFilesArr3 = [];
          if (paraObj.div4r1 == 0) {
            if (obj.radioSelect4) {
              reviewItem4Keys.forEach((item, index) => {
                if (item.includes("div4F1")) {
                  // console.info(item, index);
                  if (paraObj[item]) {
                    neededFilesArr3.push(index);
                  }
                }
              });

              let containsAll = neededFilesArr3.includes(4);
              this.hasFile = containsAll;
              if (this.hasFile && obj.radioSelect5) {
                reviewItem4Keys.forEach((item, index) => {
                  if (item.includes("div4F2")) {
                    if (paraObj[item]) {
                      neededFilesArr3.push(index);
                    }
                  }
                });
                let containsAll = neededFilesArr3.includes(5);
                this.hasFile = containsAll;
              }
            }
          } else {
            reviewItem4Keys.forEach((item, index) => {
              if (item.includes("div4F1")) {
                // console.info(item, index);
                if (paraObj[item]) {
                  neededFilesArr3.push(index);
                }
              }
            });
            let containsAll = neededFilesArr3.includes(4);
            this.hasFile = containsAll;
          }

          break;
        case "reviewItem5":
          paraObj = {
            div5t1: obj.remark || "",
            div5r1: this.radioFilter(
              obj.radioSelect1,
              obj,
              "reviewItem5div5r1"
            ),
            div5r2: obj.radioSelect2,
            div5r3: obj.selectedOptions.toString(),
            div5r4: this.radioFilter(
              obj.radioSelect3,
              obj,
              "reviewItem5div5r4"
            ),
            div5r5: obj.radioSelect4,
            div5F1: obj.fileObj1.filePath || "",
            div5F2: obj.fileObj2.filePath || "",
            div5F3: obj.fileObj3.filePath || "",
            div5F4: obj.fileObj4.filePath || "",
          };
          if (paraObj.div5r1) {
            paraObj.div5r5 = 0;
          }
          if (paraObj.div5r5 == 1) {
            paraObj.div5r2 = 0;
          } else {
            paraObj.div5r3 = 0;
          }
          const reviewItem5Keys = Object.keys(paraObj);
          let neededFilesArr4 = [];
          if (obj.radioSelect1 || obj.radioSelect3) {
            reviewItem5Keys.forEach((item, index) => {
              if (item.includes("div5F")) {
                if (paraObj[item]) {
                  neededFilesArr4.push(index);
                }
              }
            });
            const filesShouldHaveArr = [6];
            let containsAll = filesShouldHaveArr.every((i) =>
              neededFilesArr4.includes(i)
            );
            this.hasFile = containsAll;
          } else if (obj.radioSelect4 == 0) {
            reviewItem5Keys.forEach((item, index) => {
              if (item.includes("div5F")) {
                if (paraObj[item]) {
                  neededFilesArr4.push(index);
                }
              }
            });
            const filesShouldHaveArr = [6];
            let containsAll = filesShouldHaveArr.every((i) =>
              neededFilesArr4.includes(i)
            );
            this.hasFile = containsAll;
          } else {
            reviewItem5Keys.forEach((item, index) => {
              if (item.includes("div5F")) {
                if (paraObj[item]) {
                  neededFilesArr4.push(index);
                }
              }
            });
            if (paraObj.div5r3.includes(1)) {
              let containsAll = neededFilesArr4.includes(7);
              if (containsAll && paraObj.div5r3.includes(2)) {
                containsAll = neededFilesArr4.includes(8);
                this.hasFile = containsAll;
                if (containsAll && paraObj.div5r3.includes(3)) {
                  containsAll = neededFilesArr4.includes(9);
                  this.hasFile = containsAll;
                }
              } else if (containsAll && paraObj.div5r3.includes(3)) {
                containsAll = neededFilesArr4.includes(9);
                this.hasFile = containsAll;
              }
              this.hasFile = containsAll;
            } else {
              if (paraObj.div5r3.includes(2)) {
                let containsAll = neededFilesArr4.includes(8);
                this.hasFile = containsAll;
                if (containsAll && paraObj.div5r3.includes(3)) {
                  containsAll = neededFilesArr4.includes(9);
                  this.hasFile = containsAll;
                }
              } else if (paraObj.div5r3.includes(3)) {
                let containsAll = neededFilesArr4.includes(9);
                this.hasFile = containsAll;
              }
              // this.hasFile = containsAll;
            }
          }
          break;
        case "reviewItem6":
          paraObj = {
            div6t1: obj.remark || "",
            div6r1: obj.radioSelect,
            div6F1: obj.fileObj.filePath || "",
          };
          break;
        case "reviewItem7":
          paraObj = {
            div7t1: obj.remark || "",
            div7r1: obj.radioSelect1,
            div7r2: this.radioFilter(
              obj.radioSelect2,
              obj,
              "reviewItem7div7r2"
            ),
            div7r3: this.radioFilter(
              obj.radioSelect3,
              obj,
              "reviewItem7div7r3"
            ),
            div7F1: obj.fileObj1.filePath || "",
            div7F2: obj.fileObj2.filePath || "",
          };
          if (paraObj.div7r3) {
            paraObj.div7r1 = 0;
            paraObj.div7r2 = 0;
          }
          const reviewItem7Keys = Object.keys(paraObj);
          let neededFilesArr7 = [];
          const condition = obj.radioSelect1 != 0 && !obj.radioSelect2;
          if (condition || obj.radioSelect3) {
            reviewItem7Keys.forEach((item, index) => {
              if (item.includes("div7F")) {
                console.info(item, index);
                if (paraObj[item]) {
                  neededFilesArr7.push(index);
                }
              }
            });
            const filesShouldHaveArr = [4];
            let containsAll = filesShouldHaveArr.every((i) =>
              neededFilesArr7.includes(i)
            );
            paraObj.div4F2 = "";
            this.hasFile = containsAll;
          } else {
            reviewItem7Keys.forEach((item, index) => {
              if (item.includes("div7F")) {
                console.info(item, index);
                if (paraObj[item]) {
                  neededFilesArr7.push(index);
                }
              }
            });
            const filesShouldHaveArr = [4, 5];
            let containsAll = filesShouldHaveArr.every((i) =>
              neededFilesArr7.includes(i)
            );
            this.hasFile = containsAll;
          }

          break;
        case "reviewItem8":
          paraObj = {
            div8t1: obj.remark || "",
            div8r1: obj.radioSelect,
            div8F1: obj.fileObj.filePath || "",
          };
          break;
        case "reviewItem9":
          paraObj = {
            div9t1: obj.remark || "",
            div9r1: obj.radioSelect,
            div9F1: obj.fileObj.filePath || "",
          };
          break;
        case "reviewItem10":
          paraObj = {
            div10t1: obj.remark || "",
            div10r1: obj.radioSelect,
            div10F1: obj.fileObj.filePath || "",
          };
          break;

        case "reviewItem11":
          paraObj = {
            div11t1: obj.remark || "",
            div11r1: obj.radioSelect3 ? obj.radioSelect1 : 0,
            div11r2: obj.radioSelect4 ? obj.radioSelect2 : 0,
            div11F1: obj.fileObj1.filePath || "",
            div11F2: obj.fileObj2.filePath || "",
          };
          const reviewItem11Keys = Object.keys(paraObj);
          let neededFilesArr11 = [];
          if (paraObj.div11r1 == 0 && obj.radioSelect4) {
            reviewItem11Keys.forEach((item, index) => {
              if (item.includes("div11F2")) {
                if (paraObj[item]) {
                  neededFilesArr11.push(index);
                }
              }
            });
            let containsAll = neededFilesArr11.includes(4);
            this.hasFile = containsAll;
          } else {
            reviewItem11Keys.forEach((item, index) => {
              if (item.includes("div11F1")) {
                if (paraObj[item]) {
                  neededFilesArr11.push(index);
                }
              }
            });
            let containsAll = neededFilesArr11.includes(3);
            this.hasFile = containsAll;
            if (this.hasFile && obj.radioSelect4) {
              reviewItem11Keys.forEach((item, index) => {
                if (item.includes("div11F2")) {
                  if (paraObj[item]) {
                    neededFilesArr11.push(index);
                  }
                }
              });
              let containsAll = neededFilesArr11.includes(4);
              this.hasFile = containsAll;
            }
          }

          break;
        case "reviewItem12":
          paraObj = {
            div12t1: obj.remark || "",
            div12r1: obj.radioSelect,
            div12r2: obj.selectedOptions.toString(),
            div12F1: obj.fileObj1.filePath || "",
            div12F2: obj.fileObj2.filePath || "",
            div12F3: obj.fileObj3.filePath || "",
            div12F4: "",
            div12F5: "",
          };
          const reviewItem12Keys = Object.keys(paraObj);
          let neededFilesArr12 = [];
          if (obj.radioSelect && obj.selectedOptions.length < 1) {
            reviewItem12Keys.forEach((item, index) => {
              if (item.includes("div12F")) {
                if (paraObj[item]) {
                  neededFilesArr12.push(index);
                }
              }
            });
            const filesShouldHaveArr = [3];
            let containsAll = filesShouldHaveArr.every((i) =>
              neededFilesArr12.includes(i)
            );
            paraObj.div4F2 = "";
            this.hasFile = containsAll;
          } else if (obj.radioSelect && obj.selectedOptions.length == 1) {
            reviewItem12Keys.forEach((item, index) => {
              if (item.includes("div12F")) {
                if (paraObj[item]) {
                  neededFilesArr12.push(index);
                }
              }
            });
            const filesShouldHaveArr = [3, 4];
            let containsAll = filesShouldHaveArr.every((i) =>
              neededFilesArr12.includes(i)
            );
            this.hasFile = containsAll;
          } else {
            reviewItem12Keys.forEach((item, index) => {
              if (item.includes("div12F")) {
                if (paraObj[item]) {
                  neededFilesArr12.push(index);
                }
              }
            });
            const filesShouldHaveArr = [3, 4, 5];
            let containsAll = filesShouldHaveArr.every((i) =>
              neededFilesArr12.includes(i)
            );
            this.hasFile = containsAll;
          }

          break;
        case "reviewItem13":
          paraObj = {
            div13t1: obj.remark || "",
            div13r1: this.radioFilter(
              obj.radioSelect,
              obj,
              "reviewItem13div13r1"
            ),
            div13r2: obj.selectedOptions.toString(),
            div13F1: obj.fileObj1.filePath || "",
            div13F2: obj.fileObj2.filePath || "",
            div13F3: obj.fileObj3.filePath || "",
          };
          const reviewItem13Keys = Object.keys(paraObj);
          let neededFilesArr13 = [];
          if (obj.radioSelect && obj.selectedOptions.length < 1) {
            reviewItem13Keys.forEach((item, index) => {
              if (item.includes("div13F")) {
                if (paraObj[item]) {
                  neededFilesArr13.push(index);
                }
              }
            });
            const filesShouldHaveArr = [3];
            let containsAll = filesShouldHaveArr.every((i) =>
              neededFilesArr13.includes(i)
            );
            this.hasFile = containsAll;
          } else if (obj.selectedOptions.length == 3) {
            if (!obj.radioSelect) {
              reviewItem13Keys.forEach((item, index) => {
                if (item.includes("div13F")) {
                  if (paraObj[item]) {
                    neededFilesArr13.push(index);
                  }
                }
              });
              const filesShouldHaveArr = [3, 4];
              let containsAll = filesShouldHaveArr.every((i) =>
                neededFilesArr13.includes(i)
              );
              this.hasFile = containsAll;
              if (!this.hasFile) {
                reviewItem13Keys.forEach((item, index) => {
                  if (item.includes("div13F")) {
                    if (paraObj[item]) {
                      neededFilesArr13.push(index);
                    }
                  }
                });
                const filesShouldHaveArr = [3, 5];
                let containsAll = filesShouldHaveArr.every((i) =>
                  neededFilesArr13.includes(i)
                );
                this.hasFile = containsAll;
                if (!this.hasFile) {
                  reviewItem13Keys.forEach((item, index) => {
                    if (item.includes("div13F")) {
                      if (paraObj[item]) {
                        neededFilesArr13.push(index);
                      }
                    }
                  });
                  const filesShouldHaveArr = [4, 5];
                  let containsAll = filesShouldHaveArr.every((i) =>
                    neededFilesArr13.includes(i)
                  );
                  this.hasFile = containsAll;
                }
              }
            }
          } else {
            reviewItem13Keys.forEach((item, index) => {
              if (item.includes("div13F")) {
                if (paraObj[item]) {
                  neededFilesArr13.push(index);
                }
              }
            });
            const filesShouldHaveArr = [3];
            let containsAll = filesShouldHaveArr.every((i) =>
              neededFilesArr13.includes(i)
            );
            this.hasFile = containsAll;
            if (!this.hasFile) {
              reviewItem13Keys.forEach((item, index) => {
                if (item.includes("div13F")) {
                  if (paraObj[item]) {
                    neededFilesArr13.push(index);
                  }
                }
              });
              const filesShouldHaveArr = [4];
              let containsAll = filesShouldHaveArr.every((i) =>
                neededFilesArr13.includes(i)
              );
              this.hasFile = containsAll;
              if (!this.hasFile) {
                reviewItem13Keys.forEach((item, index) => {
                  if (item.includes("div13F")) {
                    if (paraObj[item]) {
                      neededFilesArr13.push(index);
                    }
                  }
                });
                const filesShouldHaveArr = [5];
                let containsAll = filesShouldHaveArr.every((i) =>
                  neededFilesArr13.includes(i)
                );
                this.hasFile = containsAll;
              }
            }
          }

          break;
        case "reviewItem14":
          paraObj = {
            div14t1: obj.remark || "",
            div14r1: obj.radioSelect,
            div14F1: obj.fileObj.filePath || "",
          };
          break;
        case "reviewItem15":
          paraObj = {
            div15t1: obj.remark || "",
            div15r1: obj.radioSelect,
            div15F1: obj.fileObj.filePath || "",
          };
          break;
        case "reviewItem16":
          paraObj = {
            div16t1: obj.remark || "",
            div16r1: obj.radioSelect,
            div16n1: obj.counter1,
            div16n2: obj.counter2,
            div16n3: obj.counter3,
            div16F1: obj.fileObj.filePath || "",
          };
          if (obj.radioSelect == 3) {
            paraObj.div16n1 = 0;
            paraObj.div16n2 = 0;
            paraObj.div16n3 = 0;
          }
          console.info("div16", paraObj);
          break;
        case "reviewItem17":
          paraObj = {
            div17t1: obj.remark || "",
            div17r1: obj.radioSelect,
            div17n1: obj.counter,
            div17F1: obj.fileObj.filePath || "",
          };
          if (obj.radioSelect == 2 || obj.radioSelect == 1) {
            paraObj.div17n1 = 0;
          }
          break;
        case "reviewItem18":
          paraObj = {
            div18t1: obj.remark || "",
            div18r1: obj.radioSelect,
            div18F1: obj.fileObj.filePath || "",
          };
          break;
        case "reviewItem19":
          paraObj = {
            div19t1: obj.remark || "",
            div19r1: obj.radioSelect,
            div19F1: obj.fileObj.filePath || "",
          };
          break;
        case "reviewItem20":
          paraObj = {
            div20t1: obj.remark || "",
            div20r1: obj.radioSelect,
            div20F1: obj.fileObj.filePath || "",
          };
          break;
        case "reviewItem21":
          paraObj = {
            div21t1: obj.remark || "",
            div21r1: obj.radioSelect,
            div21F1: obj.fileObj.filePath || "",
          };
          break;
        case "reviewItem22":
          paraObj = {
            div22t1: obj.remark || "",
            div22r1: obj.radioSelect,
            div22F1: obj.fileObj.filePath || "",
          };
          break;
        case "reviewItem23":
          paraObj = {
            div23t1: obj.remark || "",
            div23r1: obj.radioSelect,
            div23F1: obj.fileObj.filePath || "",
          };
          break;
        case "reviewItem24":
          paraObj = {
            div24t1: obj.remark || "",
            div24r1: obj.radioSelect,
            div24F1: obj.fileObj.filePath || "",
          };
          break;
        case "reviewItem25":
          paraObj = {
            div25t1: obj.remark || "",
            div25r1: obj.selectedOptions.toString() || "0",
            div25F1: obj.fileObj.filePath || "",
          };
          break;
        case "reviewItem26":
          paraObj = {
            div27t1: obj.remark || "",
            div27r1: obj.radioSelect,
            div27F1: obj.fileObj.filePath || "",
          };
          break;
        case "reviewItem27":
          paraObj = {
            div28t1: obj.remark || "",
            div28r1: obj.radioSelect,
            div28F1: obj.fileObj.filePath || "",
          };
      }
      // console.info("hasFileeeee", this.hasFile);
      if (withData && this.hasFile) {
        const { data } = await api.reviewTaskApi.submitReviewItemWithData(
          this.reviewProjectID,
          path,
          paraObj,
          dataObj
        );
        if (data.isSuccessful) {
          this.$message({
            message: "保存成功",
            type: "success",
          });
        } else {
          if (data.resultMsg) {
            this.$message({
              message: data.resultMsg,
              type: "error",
            });
          } else {
            this.$message({
              message: "发生未知错误，请联系管理员",
              type: "error",
            });
          }
        }
        // if (data.resultData) {
        //   this.reviewSubmitDatas[itemPath].score = data.resultData;
        //   console.info('write score with data', this.reviewSubmitDatas[itemPath].score)
        //   }
      } else if (this.hasFile) {
        const { data } = await api.reviewTaskApi.submitReviewItem(
          this.reviewProjectID,
          path,
          paraObj
        );
        if (data.isSuccessful) {
          this.$message({
            message: "保存成功",
            type: "success",
          });

          this.updateScore();
        } else {
          if (data.resultMsg) {
            this.$message({
              message: data.resultMsg,
              type: "error",
            });
          } else {
            this.$message({
              message: "请检查必填项（带*号）是否已填！",
              type: "error",
            });
          }
        }
        //  if (data.resultData) {
        //   this.reviewSubmitDatas[itemPath].score = parseFloat(data.resultData);
        //   console.info('write score without data', this.reviewSubmitDatas[itemPath].score)
        //   }
      } else {
        alert("请上传附件！");
      }
      this.getBackUp();
    },

    deToxicateArr(arr) {
      if (arr) {
        const x = arr.split(",");
        let newArr = [];
        x.forEach((item) => {
          const t = parseInt(item);
          if (t === t) {
            newArr.push(t.toString());
          }
        });
        return newArr;
      } else {
        return [0];
      }
    },
    async submitReviewResult() {
      const { data } = await api.reviewTaskApi.SubmitToAudit(this.companyID);
      if (data.isSuccessful) {
        this.$message({
          message: "提交成功",
          type: "success",
        });
        // const res = await api.reviewTaskApi.delSubmitData(this.companyID);
      } else {
        if (data.resultMsg) {
          this.$message({
            message: data.resultMsg,
            type: "error",
          });
        } else {
          this.$message({
            message: "发生未知错误，请联系管理员",
            type: "error",
          });
        }
      }
    },
  },
};
</script>

<style lang="sass" scoped>
@use "../../assets/scss/reviewSubmit.scss" as *
</style>

